<template>
  <v-layout row wrap class="event-page my-2 mx-0" align-center>
    <v-flex
      v-if="!event || !event._id || event._id.toString() !== $route.params.id"
      xs12 offset-xs0 sm12 offset-sm0 md10 offset-md1 lg8 offset-lg2
    >
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </v-flex>
    <v-flex v-else xs12 offset-xs0 sm12 offset-sm0 md10 offset-md1 lg8 offset-lg2>
      <v-card outlined>
        <v-card-title class="event-header py-2 px-3">
          <v-btn text color="blue" :to="`/season/${event.season._id}?tab=calendar`" class="event-back-button mr-2 px-2"
          ><v-icon>mdi-chevron-left</v-icon> <span v-if="$vuetify.breakpoint.mdAndUp">Inapoi</span>
          </v-btn
        >
          <span class="event-title font-weight-black text-h4 text-uppercase">{{ event.title }}</span>
          <v-spacer></v-spacer>
          <v-dialog v-model="rsvpDialog" persistent max-width="400" v-if="rsvpDateGood">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" :disabled="!rsvpOpen || driverSuspended">
                <span v-if="driverSuspended">Suspendat</span>
                <span v-else-if="rsvpCar || hasUserResponded">Modifică RSVP</span>
                <span v-else>Confirmă prezența</span>
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="headline">
                Vei fi prezent la cursa?
              </v-card-title>

              <v-card-text
                >Alege mașina în care vei concura la cursă și apasă 'Prezent' dacă vei veni la cursă. Te poți răzgândi
                oricând apăsând 'Absent'.

                <v-select
                  :items="userAvailableCars"
                  label="Masina"
                  v-model="rsvpDialogCar"
                  return-object
                  @change="rsvpCarChanged"
                >
                  <template v-slot:selection="data">
                    #{{data.item.raceNumber}} {{data.item.carName}}
                  </template>
                  
                  <template v-slot:item="data">
                    #{{data.item.raceNumber}} {{data.item.carName}}
                  </template>
                </v-select>

                <v-select
                  v-if="rsvpDialogCar && carNeedsFirstDriverSet"
                  :disabled="!rsvpDialogCar"
                  :items="rsvpAvailableDrivers"
                  item-value="_id"
                  v-model="firstDriver"
                  label="Pilotul care se conectează primul la server"
                  return-object
                >
                  <template v-slot:selection="data">
                    {{data.item.profile.firstName}} {{data.item.profile.lastName}}
                  </template>
                  
                  <template v-slot:item="data">
                    {{data.item.profile.firstName}} {{data.item.profile.lastName}}
                  </template>
                </v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="cancelRSVPDialog()">
                  Anuleaza
                </v-btn>
                <v-btn color="red darken-1" dark @click="resetRSVPCar()">
                  Absent
                </v-btn>
                <v-btn
                  color="green darken-1"
                  :dark="!!rsvpDialogCar"
                  :outlined="!rsvpDialogCar"
                  :disabled="!rsvpDialogCar"
                  @click="confirmRSVP()"
                >
                  Prezent
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-tabs color="blue" centered icons-and-text v-model="tab">
            <v-tab href="#info">Info<v-icon>mdi-information</v-icon></v-tab>
            <!-- v-tab href="#track">Circuit<v-icon>mdi-road-variant</v-icon></v-tab -->
            <v-tab href="#registrations">
              Participanți<v-icon>mdi-car-multiple</v-icon>
            </v-tab>
            <v-tab v-if="officialSessions.length > 0 || canUserEditResults" href="#results">Rezultate<v-icon>mdi-clipboard-list</v-icon></v-tab>

              <v-tab-item value="info" class="event-tab-content">
                <v-row dense>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 4">
                    <v-card-title class="py-2">Circuit</v-card-title>
                    <v-list v-if="event" class="py-0">
                      <template>
                        <v-list-item dense>
                          <v-list-item-action><v-icon>mdi-road-variant</v-icon></v-list-item-action>

                          <v-list-item-content>
                            <span>{{ event.track.trackFamily.name }} {{ event.track.name }}</span>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense>
                          <v-list-item-action><v-icon>mdi-map-marker</v-icon></v-list-item-action>

                          <v-list-item-content>
                            <span>{{ event.track.trackFamily.country }}, {{ event.track.trackFamily.city }}</span>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list>
                    <v-card-title class="py-2">Reguli</v-card-title>
                    <v-list v-if="event" class="py-0">
                      <v-list-item dense>
                        <v-list-item-action>
                          <v-icon>mdi-account-group</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                          <span v-if="event.season.rules.minCarsPerTeam == event.season.rules.maxCarsPerTeam"
                            >{{ event.season.rules.minCarsPerTeam }}
                            {{ event.season.rules.minCarsPerTeam > 1 ? "mașini" : "mașină" }} pentru fiecare club</span
                          >
                          <span v-else
                            >Între {{ event.season.rules.minCarsPerTeam }} și
                            {{ event.season.rules.maxCarsPerTeam }} mașini pentru fiecare club</span
                          >
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item dense>
                        <v-list-item-action>
                          <v-icon>mdi-racing-helmet</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                          <span v-if="event.season.rules.minDriversPerCar == event.season.rules.maxDriversPerCar"
                            >{{ event.season.rules.minDriversPerCar }}
                            {{ event.season.rules.minDriversPerCar > 1 ? "piloți" : "pilot" }} în fiecare mașină</span
                          >
                          <span v-else
                            >Între {{ event.season.rules.minDriversPerCar }} si
                            {{ event.season.rules.maxDriversPerCar }} piloți în fiecare mașină</span
                          >
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item dense>
                        <v-list-item-action>
                          <v-icon>mdi-car</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                          <span>{{ event.season.rules.maxCarsPerSplit }} mașini per split</span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 8">
                    <v-card-title class="py-2">Program</v-card-title>
                    <v-timeline dense class="pt-1">
                      <v-timeline-item
                        v-for="(session, i) in event.sessions"
                        :key="i"
                        :color="timelineColor(session)"
                        small
                        class="pr-2"
                      >
                        <v-card outlined>
                      <v-sheet
                        :color="timelineColor(session)"
                      >
                            <v-card-title class="text-h6 text-uppercase font-weight-black white--text ma-0 py-2">{{session.title}}</v-card-title>
                            <v-card-subtitle class="text-subtitle-2 white--text pb-2">{{printDate(session.startDate)}}</v-card-subtitle>
                          </v-sheet>
                          <v-list dense two-line>
                            <v-list-item v-if="session.serverName!=''">
                              <v-list-item-action class="my-0 py-0">
                                <v-icon>mdi-server-network</v-icon>
                              </v-list-item-action>
                              <v-list-item-content class="my-0 py-0">
                                <strong>Server</strong><span class="text-caption">{{session.serverName}}</span>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="session.password!=''">
                              <v-list-item-action class="my-0 py-0">
                                <v-icon>mdi-key</v-icon>
                              </v-list-item-action>
                              <v-list-item-content class="my-0 py-0">
                                <template v-if="driverInRegisteredCar">
                                  <strong>Parola</strong><span class="text-caption">{{session.password}}</span>
                                </template>
                                <span v-else class="font-italic">
                                  Parola e disponibilă doar piloților înscriși
                                </span>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="session.type.code=='Q' && !session.official">
                              <v-list-item-action class="my-0 py-0">
                                <v-icon>mdi-alarm-check</v-icon>
                              </v-list-item-action>
                              <v-list-item-content class="my-0 py-0">
                                <strong>Deadline</strong><span class="text-caption">Se încheie la {{printDate ( new Date (session.startDate).getTime()+session.durationMinutes*60000)}}</span>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="session.type.code!='Q' || session.official">
                              <v-list-item-action class="my-0 py-0">
                                <v-icon>mdi-clock</v-icon>
                              </v-list-item-action>
                              <v-list-item-content class="my-0 py-0">
                                <strong>Durată</strong><span class="text-caption">{{session.durationMinutes}} de minute</span>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="session.hotstintLaps>1">
                              <v-list-item-action class="my-0 py-0">
                                <v-icon>mdi-calculator</v-icon>
                              </v-list-item-action>
                              <v-list-item-content class="my-0 py-0">
                                <strong>Calcul rezultat</strong><span class="text-caption">Medie pe {{session.hotstintLaps}} tururi consecutive valide</span>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="session.reverseGridPositions>1">
                              <v-list-item-action class="my-0 py-0">
                                <v-icon>mdi-calculator</v-icon>
                              </v-list-item-action>
                              <v-list-item-content class="my-0 py-0">
                                <strong>Grilă inversată</strong><span class="text-caption">Top {{session.reverseGridPositions}}</span>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>
                  </v-col>
                </v-row>
              </v-tab-item>
              <!-- v-tab-item value="track">
                <v-row>
                  <v-col xs12 s12 md12 lg12>
                  </v-col>
                </v-row>
              </v-tab-item -->
              <v-tab-item value="registrations">
                <v-container fluid class="pa-2">
                  <IRacingPrequalAdmin :event="event" :default-average-laps="prequalRequiredLaps" @imported="refreshIracingResults" />
                  <v-row dense v-if="event.season.rules.prequalEnabled && entrylist.prequal.bestResult">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : (prequalLastUpdatedAt ? 4 : 6)">
                      <v-icon>mdi-timer-outline</v-icon> Reper: {{ printLaptime(entrylist.prequal.bestResult) }}
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : (prequalLastUpdatedAt ? 4 : 6)">
                      <v-icon>mdi-timer-off-outline</v-icon> Barem participare:
                      {{ printLaptime(entrylist.prequal.thresholdResult) }}
                    </v-col>
                    <v-col v-if="prequalLastUpdatedAt" :cols="$vuetify.breakpoint.smAndDown ? 12 : 4">
                      <v-icon>mdi-update</v-icon> Ultima actualizare: <v-tooltip top><template v-slot:activator="{ on }"><span class="text-decoration-underline" style="cursor: help;" v-on="on">{{printDate(prequalLastUpdatedAt)}}</span></template><span>Ora ta, tinere. Te pup.</span></v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="canUserDownloadEntrylist">
                    <v-col cols="12" align="left">
                      <v-btn
                        text
                        tile
                        color="green"
                        @click="downloadEntrylist()"
                      >
                        <v-icon left>mdi-download</v-icon>Descarcă entrylist
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col class="prequal-table-column">
                      <div v-if="$vuetify.breakpoint.smAndDown" class="prequal-mobile-list">
                        <template v-for="(item, index) in filteredEntrylist">
                          <div v-if="index === 0 || filteredEntrylist[index - 1].Split !== item.Split" :key="`split-${item.Split}`" class="prequal-mobile-split text--secondary">Split {{item.Split}}</div>
                          <v-card :key="item.car._id" flat tile class="prequal-mobile-card">
                            <v-card-text class="px-3 py-2">
                              <template v-if="!isTeamRace">
                                <v-row
                                  v-for="(driver, driverIndex) in item.drivers"
                                  :key="driver.user._id"
                                  no-gutters
                                  align="start"
                                  class="prequal-mobile-driver-row"
                                >
                                  <v-col cols="2" class="d-flex justify-center">
                                    <v-avatar size="56" color="grey darken-1">
                                      <v-img v-if="driverAvatarUrl(driver)" :src="driverAvatarUrl(driver)" :alt="`Avatar ${driver.driverName}`"></v-img>
                                      <v-icon v-else dark>mdi-account</v-icon>
                                    </v-avatar>
                                  </v-col>
                                  <v-col cols="7" class="pl-2 prequal-mobile-driver-copy">
                                    <div class="d-flex align-center mb-1">
                                      <span class="prequal-driver__number">#{{item.car.raceNumber}}</span>
                                      <kbd
                                        v-for="(driverClass, kindex) in getUserClasses(driver.user._id)"
                                        :key="kindex"
                                        class="mr-1 driver-class"
                                        :class="{ 'driver-class--secondary': kindex > 0 }"
                                        :style="{ backgroundColor: driverClass.backgroundColor || '#424242', color: driverClass.textColor || '#ffffff' }"
                                      >{{driverClass.acronym}}</kbd>
                                    </div>
                                    <div class="text-body-1 font-weight-bold text--primary text-truncate">
                                      <router-link v-if="isLoggedIn" class="driver-profile-link" :to="`/driver-profile/${driver.user._id}`">{{driver.driverName}}</router-link>
                                      <template v-else>{{driver.driverName}}</template>
                                    </div>
                                    <div class="text-caption text--secondary text-uppercase text-truncate">{{prequalDriverSubtitle(item)}}</div>
                                  </v-col>
                                  <v-col v-if="driverIndex === 0" cols="3" class="prequal-mobile-driver-summary text-right">
                                    <div :class="['prequal-mobile-position', prequalPositionClass(item.position)]">P{{item.position}}</div>
                                    <v-chip
                                      v-if="entrylist.rlrRatingAvailable"
                                      x-small
                                      class="mt-1 rlr-rating-chip"
                                      :title="`RLR Rating: ${driverRlrRatingValue(driver)}`"
                                    >{{shortRlrRating(driverRlrRatingValue(driver))}}</v-chip>
                                    <v-chip
                                      v-if="driver.licensePoints"
                                      x-small
                                      :class="['mt-1', 'license-points-chip', licensePointChipClass(driver.licensePoints.currentThreshold)]"
                                      @click="openLicensePointDialog(driver)"
                                    >{{driver.licensePoints.total}} LP</v-chip>
                                  </v-col>
                                  <v-col v-else cols="3"></v-col>
                                </v-row>
                              </template>
                              <template v-else>
                                <v-row no-gutters align="start" class="prequal-mobile-team-header-row">
                                  <v-col cols="9" class="d-flex align-start prequal-mobile-driver-copy">
                                    <kbd
                                      v-for="(carClass, kindex) in item.car.classes"
                                      :key="kindex"
                                      class="mr-2 driver-class prequal-mobile-team-car-class"
                                      :class="{ 'driver-class--secondary': kindex > 0 }"
                                      :style="{
                                        backgroundColor: carClass.backgroundColor || '#424242',
                                        color: carClass.textColor || '#ffffff'
                                      }"
                                    >{{carClass.acronym}}</kbd>
                                    <div class="prequal-mobile-team-entry-copy">
                                      <div class="text-body-1 font-weight-bold text--primary text-truncate">
                                        <span class="prequal-driver__number">#{{item.car.raceNumber}}</span>{{item.car.carName}}
                                      </div>
                                      <div class="text-caption text--secondary text-uppercase text-truncate">{{prequalDriverSubtitle(item)}}</div>
                                    </div>
                                  </v-col>
                                  <v-col cols="3" class="text-right">
                                    <div :class="['prequal-mobile-position', 'prequal-mobile-team-position', prequalPositionClass(item.position)]">P{{item.position}}</div>
                                  </v-col>
                                </v-row>
                                <v-row
                                  v-for="driver in item.drivers"
                                  :key="driver.user._id"
                                  no-gutters
                                  align="center"
                                  class="prequal-mobile-team-driver-row"
                                >
                                  <v-col cols="2" class="d-flex justify-center">
                                    <v-avatar size="36" color="grey darken-1">
                                      <v-img v-if="driverAvatarUrl(driver)" :src="driverAvatarUrl(driver)" :alt="`Avatar ${driver.driverName}`"></v-img>
                                      <v-icon v-else small dark>mdi-account</v-icon>
                                    </v-avatar>
                                  </v-col>
                                  <v-col cols="7" class="pl-2 d-flex align-center prequal-mobile-team-driver-copy">
                                    <kbd
                                      v-for="(driverClass, kindex) in getUserClasses(driver.user._id)"
                                      :key="kindex"
                                      class="mr-2 driver-class"
                                      :class="{ 'driver-class--secondary': kindex > 0 }"
                                      :style="{ backgroundColor: driverClass.backgroundColor || '#424242', color: driverClass.textColor || '#ffffff' }"
                                    >{{driverClass.acronym}}</kbd>
                                    <div class="font-weight-bold text--primary text-truncate">
                                      <router-link v-if="isLoggedIn" class="driver-profile-link" :to="`/driver-profile/${driver.user._id}`">{{driver.driverName}}</router-link>
                                      <template v-else>{{driver.driverName}}</template>
                                    </div>
                                  </v-col>
                                  <v-col cols="3" class="d-flex flex-column align-end">
                                    <v-chip
                                      v-if="entrylist.rlrRatingAvailable"
                                      x-small
                                      class="rlr-rating-chip"
                                      :title="`RLR Rating: ${driverRlrRatingValue(driver)}`"
                                    >{{shortRlrRating(driverRlrRatingValue(driver))}}</v-chip>
                                    <v-chip
                                      v-if="driver.licensePoints"
                                      x-small
                                      :class="[
                                        {'mt-1': entrylist.rlrRatingAvailable},
                                        'license-points-chip',
                                        licensePointChipClass(driver.licensePoints.currentThreshold)
                                      ]"
                                      @click="openLicensePointDialog(driver)"
                                    >{{driver.licensePoints.total}} LP</v-chip>
                                  </v-col>
                                </v-row>
                              </template>
                              <v-divider class="prequal-mobile-section-divider"></v-divider>
                              <v-row no-gutters align="center" class="prequal-mobile-detail-row prequal-mobile-detail-row--car">
                                <v-col cols="2" class="text-center"><v-icon large color="blue-grey lighten-1">mdi-steering</v-icon></v-col>
                                <v-col cols="5" class="pl-2 prequal-mobile-car-copy">
                                  <template v-if="carHasLiveryPreview(item.car.raceNumber)">
                                    <div class="prequal-car__make text--secondary">{{carModelTitleParts(item.car.carModel.title).make}}</div>
                                    <div class="prequal-car__model text-truncate">{{carModelTitleParts(item.car.carModel.title).model}}</div>
                                  </template>
                                  <div v-else class="caption font-weight-bold text--secondary">MAȘINA</div>
                                </v-col>
                                <v-col cols="5" class="d-flex justify-end">
                                  <v-img
                                    v-if="carHasLiveryPreview(item.car.raceNumber)"
                                    :src="carLiveryPreviewURL(item.car.raceNumber)"
                                    @error="handleCarLiveryError(item.car.raceNumber)"
                                    width="130"
                                    height="60"
                                    contain
                                    class="prequal-mobile-car-image"
                                  />
                                  <div v-else class="prequal-mobile-car-fallback text-right">
                                    <div class="prequal-car__make text--secondary">{{carModelTitleParts(item.car.carModel.title).make}}</div>
                                    <div class="prequal-car__model text-truncate">{{carModelTitleParts(item.car.carModel.title).model}}</div>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row no-gutters align="center" class="prequal-mobile-detail-row prequal-mobile-detail-row--result">
                                <v-col cols="2" class="d-flex justify-center">
                                  <div class="prequal-mobile-average-indicator blue-grey--text text--lighten-1" role="img" :aria-label="prequalResultCalculationLabel">
                                    <v-icon :size="prequalRequiredLaps > 1 ? 15 : 20" color="blue-grey lighten-1" aria-hidden="true">mdi-timer-outline</v-icon>
                                    <template v-if="prequalRequiredLaps > 1">
                                      <div class="prequal-mobile-average-indicator__line"></div>
                                      <div class="prequal-mobile-average-indicator__laps">{{prequalRequiredLaps}}</div>
                                    </template>
                                  </div>
                                </v-col>
                                <v-col cols="5" class="pl-2">
                                  <div class="prequal-result__average">{{printLaptime(item.prequal.result)}}</div>
                                  <div class="prequal-result__laps text--secondary">{{item.totalLaps || '—'}} ({{getLapPercentage(item.validLaps, item.totalLaps)}} valide)</div>
                                </v-col>
                                <v-col cols="5" class="text-right">
                                  <div class="caption font-weight-bold text--secondary">DIFERENȚĂ</div>
                                  <span v-if="isPrequalLeader(item)" class="prequal-gap prequal-gap--leader">LIDER</span>
                                  <span v-else-if="prequalLeader && hasValidPrequalResult(item)" class="prequal-gap prequal-mobile-gap deep-orange--text text--lighten-1">+{{printTimeDifference(Math.abs(item.prequal.result - prequalLeader.prequal.result))}}</span>
                                  <span v-else class="text--secondary">—</span>
                                </v-col>
                              </v-row>
                              <v-row no-gutters align="center" class="prequal-mobile-detail-row prequal-mobile-detail-row--attendance">
                                <v-col cols="2" class="text-center"><v-icon size="30" color="green lighten-1">mdi-account-group</v-icon></v-col>
                                <v-col cols="5" class="pl-2 caption font-weight-bold text--secondary">PREZENȚĂ</v-col>
                                <v-col cols="5" class="text-right">
                                  <v-btn
                                    :color="entryStatusColor(item)"
                                    :dark="item.rsvpTeamStatus != 'unanswered'"
                                    :outlined="item.rsvpTeamStatus == 'unanswered'"
                                    :title="entryStatusLabel(item)"
                                    min-width="72"
                                    @click="showCar(item.car._id)"
                                  ><v-icon>{{entryStatusIcon(item)}}</v-icon></v-btn>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </template>
                      </div>
                      <v-data-table
                        v-show="$vuetify.breakpoint.mdAndUp"
                        class="prequal-registration-table"
                        :headers="computedSeasonRegistrationsTableHeaders"
                        :items="filteredEntrylist"
                        group-by="Split"
                        disable-pagination
                        hide-default-footer
                        :header-props="{ 'disable-sort': true }"
                      >
                        <template v-slot:[`item.carName`]="{ item }">
                          <kbd v-if="item.status == CAR_STATUS_WILDCARD" class="mr-1">*</kbd>
                          <kbd 
                            v-for="(carClass, kindex) in item.car.classes"
                            :key="kindex"
                            class="mr-1 driver-class"
                            :class="{ 'driver-class--secondary': kindex > 0 }"
                            :style="{
                              backgroundColor: carClass.backgroundColor || '#424242',
                              color: carClass.textColor || '#ffffff'
                            }"
                          >
                            {{carClass.acronym}}
                          </kbd>
                          <span class="race-number">#{{item.car.raceNumber}}</span> {{item.car.carName}}
                        </template>
                        <template v-slot:[`item.carModel`]="{ item }">
                          <div class="prequal-car">
                            <div class="prequal-car__name">
                              <div
                                v-if="carModelTitleParts(item.car.carModel.title).make"
                                class="prequal-car__make text--secondary"
                              >
                                {{carModelTitleParts(item.car.carModel.title).make}}
                              </div>
                              <div class="prequal-car__model">
                                {{carModelTitleParts(item.car.carModel.title).model}}
                              </div>
                            </div>
                            <v-img
                              v-if="carHasLiveryPreview(item.car.raceNumber)"
                              :src="carLiveryPreviewURL(item.car.raceNumber)"
                              @error="handleCarLiveryError(item.car.raceNumber)"
                              width="110"
                              height="44"
                              class="prequal-car__image"
                            />
                          </div>
                        </template>
                        <template v-slot:[`item.prettyPrequalTime`]="{ item }">
                          <div class="prequal-result">
                            <div class="prequal-result__average">
                              {{printLaptime(item.prequal.result)}}
                            </div>
                            <div class="prequal-result__laps text--secondary">
                              {{item.totalLaps || '—'}} ({{getLapPercentage(item.validLaps, item.totalLaps)}} valide)
                            </div>
                          </div>
                        </template>
                        <template v-slot:[`item.leaderGap`]="{ item }">
                          <span
                            v-if="isPrequalLeader(item)"
                            class="prequal-gap prequal-gap--leader"
                          >LIDER</span>
                          <span
                            v-else-if="prequalLeader && hasValidPrequalResult(item)"
                            class="prequal-gap deep-orange--text text--lighten-1"
                          >+{{printTimeDifference(Math.abs(item.prequal.result - prequalLeader.prequal.result))}}</span>
                          <span v-else class="text--secondary">—</span>
                        </template>
                        <template v-slot:[`item.drivers`]="{ item }">
                          <div class="prequal-drivers">
                            <div v-for="driver in item.drivers" :key="driver.user._id" class="prequal-driver">
                              <v-avatar size="44" color="grey darken-1" class="prequal-driver__avatar">
                                <v-img
                                  v-if="driverAvatarUrl(driver)"
                                  :src="driverAvatarUrl(driver)"
                                  :alt="`Avatar ${driver.driverName}`"
                                ></v-img>
                                <v-icon v-else dark>mdi-account</v-icon>
                              </v-avatar>
                              <div class="prequal-driver__details">
                                <div class="prequal-driver__identity">
                                  <span
                                    v-if="!isTeamRace"
                                    class="prequal-driver__number"
                                    :style="{ width: prequalRaceNumberWidth }"
                                  >
                                    #{{item.car.raceNumber}}
                                  </span>
                                  <kbd
                                    v-for="(driverClass, kindex) in getUserClasses(driver.user._id)"
                                    :key="kindex"
                                    class="mr-1 driver-class"
                                    :class="{ 'driver-class--secondary': kindex > 0 }"
                                    :style="{
                                      backgroundColor: driverClass.backgroundColor || '#424242',
                                      color: driverClass.textColor || '#ffffff'
                                    }"
                                  >
                                    {{driverClass.acronym}}
                                  </kbd>
                                  <router-link
                                    v-if="isLoggedIn"
                                    class="driver-profile-link"
                                    :to="`/driver-profile/${driver.user._id}`"
                                    :title="`Vezi profilul lui ${driver.driverName}`"
                                    :aria-label="`Vezi profilul lui ${driver.driverName}`"
                                  >{{driver.driverName}}<v-icon x-small>mdi-account-circle-outline</v-icon></router-link>
                                  <template v-else>{{driver.driverName}}</template>
                                  <span v-if="isUserWildcard(driver.user._id)"> (Wildcard)</span>
                                  <v-chip
                                    v-if="entrylist.rlrRatingAvailable"
                                    x-small
                                    class="ml-2 rlr-rating-chip prequal-driver__rating-chip"
                                    :title="`RLR Rating: ${driverRlrRatingValue(driver)}`"
                                  >{{shortRlrRating(driverRlrRatingValue(driver))}}</v-chip>
                                </div>
                                <div class="prequal-driver__subtitle-row">
                                  <div class="prequal-driver__subtitle text--secondary text-uppercase">
                                    {{prequalDriverSubtitle(item)}}
                                  </div>
                                  <span
                                    :class="[
                                      'prequal-driver__subtitle-metrics',
                                      'ml-2',
                                      {'prequal-driver__subtitle-metrics--rating-slot': !entrylist.rlrRatingAvailable}
                                    ]"
                                  >
                                    <v-tooltip v-if="activeLicensePointConsequences(driver).length" bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <button
                                          v-bind="attrs"
                                          v-on="on"
                                          type="button"
                                          :class="['prequal-driver__lp-decision', 'license-point-decision-indicator', licensePointDecisionIndicatorClass(driver)]"
                                          aria-label="Decizie LP în aplicare"
                                          @click="openLicensePointDialog(driver)"
                                        >!</button>
                                      </template>
                                      <div v-for="consequence in activeLicensePointConsequences(driver)" :key="consequence._id" class="license-point-decision-tooltip-line">
                                        {{licensePointThresholdLabel(consequence.type)}} — ÎN APLICARE; Etapa vizată: {{licensePointConsequenceTargetLabel(consequence.targetEvent)}}<strong v-if="licensePointConsequenceTargetPassed(consequence)"> · ETAPĂ DEPĂȘITĂ</strong>
                                      </div>
                                    </v-tooltip>
                                    <v-tooltip v-if="driver.licensePoints" bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-chip
                                          v-bind="attrs"
                                          v-on="on"
                                          x-small
                                          :class="['license-points-chip', licensePointChipClass(driver.licensePoints.currentThreshold)]"
                                          @click="openLicensePointDialog(driver)"
                                        >{{driver.licensePoints.total}} LP</v-chip>
                                      </template>
                                      <span>Deschide detaliile punctelor de licență</span>
                                    </v-tooltip>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-slot:[`item.bestLap`]="{ item }">
                          <div class="prequal-best-laps">
                            <div v-for="driver in item.prequal.drivers" :key="driver.user._id" class="prequal-best-lap">
                              <div :class="['prequal-best-lap__time', {'purple--text text--darken-1': isFastestPrequalLap(driver.bestLapTime)}]">
                                {{hasValidBestLap(driver.bestLapTime) ? printLaptime(driver.bestLapTime) : '—'}}
                              </div>
                              <div v-if="hasValidBestLap(driver.bestLapTime)" :class="['prequal-best-lap__label', {'purple--text text--darken-1': isFastestPrequalLap(driver.bestLapTime)}]">
                                <v-icon x-small :color="isFastestPrequalLap(driver.bestLapTime) ? 'purple darken-1' : 'grey darken-1'">mdi-timer-outline</v-icon>
                                {{isFastestPrequalLap(driver.bestLapTime) ? 'FASTEST LAP' : 'BEST LAP'}}
                              </div>
                            </div>
                          </div>
                        </template>
                        <template v-slot:[`item.rsvpStatus`]="{ item }">
                          <v-dialog
                            v-model="carInfoDialog[item.car._id]"
                            max-width="700"
                            @click:outside="carInfoDialog[item.car._id] = false"
                            scrollable
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                :color="entryStatusColor(item)"
                                :dark="item.rsvpTeamStatus != 'unanswered'"
                                :outlined="item.rsvpTeamStatus == 'unanswered'"
                                :title="entryStatusLabel(item)"
                                v-on="on"
                              >
                                <v-icon>{{entryStatusIcon(item)}}</v-icon>
                              </v-btn>
                            </template>

                            <v-card class="pb-1">
                              <v-card-title
                                ><span class="headline">{{ item.car.carName }}</span></v-card-title
                              >

                              <v-card-subtitle>
                                <span
                                  v-if="
                                    item.status == CAR_STATUS_RED ||
                                      item.status == CAR_STATUS_TIME ||
                                      item.status == CAR_STATUS_UNKNOWN ||
                                      item.status == CAR_STATUS_SUSPENDED
                                  "
                                >
                                  Mașina nu poate participa
                                </span>
                                <span v-else>Mașina poate participa</span>
                                <div>{{teamRSVPLabel(item.rsvpTeamStatus)}}</div>
                              </v-card-subtitle>

                              <v-card-text style="max-height: 300px">
                                <v-row class="mx-1" dense>
                                  <v-col
                                    :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
                                    v-for="driver in item.prequal.drivers"
                                    :key="driver._id"
                                  >
                                    <v-card elevation="0" outlined>
                                      <v-card-title class="text-h6 font-weight-regular">
                                        <router-link
                                          v-if="isLoggedIn"
                                          class="driver-profile-link"
                                          :to="`/driver-profile/${driver.user._id}`"
                                          :title="`Vezi profilul lui ${driver.driverName}`"
                                          :aria-label="`Vezi profilul lui ${driver.driverName}`"
                                        >{{driver.driverName}}<v-icon x-small>mdi-account-circle-outline</v-icon></router-link>
                                        <template v-else>{{driver.driverName}}</template>
                                        <span class="ml-1" v-if="driver.resultStatus == DRIVER_STATUS_WILDCARD">(Wildcard)</span>
                                      </v-card-title>
                                      <v-list>
                                        <v-list-item v-if="event.season.rules.prequalEnabled">
                                          <v-list-item-avatar>
                                            <v-icon
                                              v-if="driver.resultStatus != DRIVER_STATUS_TIME && driver.resultStatus != DRIVER_STATUS_SUSPENDED"
                                              color="green"
                                              >mdi-timer-outline</v-icon
                                            >
                                            <v-icon v-else color="red">mdi-timer-off-outline</v-icon>
                                          </v-list-item-avatar>

                                          <v-list-item-content>
                                            <span v-if="driver.result != 2147483647">
                                              {{printLaptime(driver.result)}}
                                              <span v-if="driver.resultStatus==DRIVER_STATUS_TIME">(Peste barem)</span>
                                            </span>
                                            <span v-else>
                                              Fără rezultat valid în precalificări
                                            </span>
                                          </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                          <v-list-item-avatar>
                                            <v-icon
                                              :color="driver.resultStatus == DRIVER_STATUS_SUSPENDED ? 'red' : driverRSVPColor(driver.rsvpResponseStatus)"
                                            >{{driver.resultStatus == DRIVER_STATUS_SUSPENDED ? 'mdi-cancel' : driverRSVPIcon(driver.rsvpResponseStatus)}}</v-icon>
                                          </v-list-item-avatar>

                                          <v-list-item-content>
                                            <span v-if="driver.resultStatus == DRIVER_STATUS_SUSPENDED">Suspendat</span>
                                            <span v-else>{{driverRSVPLabel(driver)}}</span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-dialog v-model="licensePointDialog" max-width="720" scrollable>
                    <v-card v-if="selectedLicensePointDriver">
                      <v-card-title class="d-flex align-center">
                        <span>{{selectedLicensePointDriver.driverName}}</span>
                        <v-chip :class="['ml-3', 'license-points-summary-chip', licensePointChipClass(selectedLicensePointDriver.licensePoints.currentThreshold)]">{{selectedLicensePointDriver.licensePoints.total}} LP</v-chip>
                      </v-card-title>
                      <v-card-text>
                        <v-alert v-if="selectedLicensePointDriver.licensePoints.currentThreshold" dense text :color="licensePointThresholdColor(selectedLicensePointDriver.licensePoints.currentThreshold)">Pragul curent: {{licensePointThresholdLabel(selectedLicensePointDriver.licensePoints.currentThreshold)}}</v-alert>
                        <div class="d-flex align-center mb-1">
                          <span class="text-subtitle-1 font-weight-bold">Etape curate</span>
                          <div class="license-point-clean-progress ml-3">
                            <span
                              v-for="round in event.season.rules.licensePoints.cleanRoundsRequired"
                              :key="round"
                              :class="['license-point-clean-progress__dot', {'license-point-clean-progress__dot--complete': round <= selectedLicensePointDriver.licensePoints.cleanRoundsProgress}]"
                            ></span>
                            <span class="license-point-clean-progress__count">{{selectedLicensePointDriver.licensePoints.cleanRoundsProgress}} / {{event.season.rules.licensePoints.cleanRoundsRequired}}</span>
                          </div>
                        </div>
                        <div class="caption text--secondary mb-4">−{{event.season.rules.licensePoints.cleanRoundsReward}} LP {{licensePointCleanRewardRemainingLabel(selectedLicensePointDriver.licensePoints.cleanRoundsProgress)}}</div>

                        <div class="text-subtitle-1 font-weight-bold mb-1">Praguri</div>
                        <v-list dense outlined class="mb-4">
                          <v-list-item v-for="threshold in licensePointThresholds" :key="threshold.type">
                            <v-list-item-content>
                              <v-list-item-title>{{threshold.value}} LP · {{licensePointThresholdLabel(threshold.type)}}</v-list-item-title>
                              <v-list-item-subtitle>{{threshold.description}}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon><v-icon :color="selectedLicensePointDriver.licensePoints.total >= threshold.value ? licensePointThresholdColor(threshold.type) : 'grey'">{{selectedLicensePointDriver.licensePoints.total >= threshold.value ? 'mdi-alert-circle' : 'mdi-circle-outline'}}</v-icon></v-list-item-icon>
                          </v-list-item>
                        </v-list>

                        <div class="d-flex align-center mb-1">
                          <span class="text-subtitle-1 font-weight-bold">Istoric praguri și consecințe</span>
                          <v-spacer></v-spacer>
                          <v-btn v-if="isAdministrator" small text color="primary" @click="addLicensePointAdjustment(selectedLicensePointDriver)">Corecție LP</v-btn>
                        </div>
                        <v-alert v-if="!selectedLicensePointDriver.licensePoints.crossings.length" dense text type="info">Nu există praguri atinse.</v-alert>
                        <template v-else>
                          <v-alert dense text type="info" class="mb-2">
                            Fiecare depasire de prag apare o singură dată. Administratorii stabilesc etapa aplicării.
                          </v-alert>
                          <v-list dense outlined class="mb-4">
                          <v-list-item
                            v-for="crossing in selectedLicensePointDriver.licensePoints.crossings"
                            :key="crossing._id"
                            :class="{'license-point-crossing--superseded': !crossing.valid}"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{crossing.thresholdValue}} LP · {{licensePointThresholdLabel(crossing.thresholdType)}}</v-list-item-title>
                              <v-list-item-subtitle>Atins după {{licensePointCrossingEventLabel(crossing.event)}} · Total: {{crossing.pointsAtCrossing}} LP</v-list-item-subtitle>
                              <v-list-item-subtitle v-if="licensePointConsequenceForCrossing(selectedLicensePointDriver.licensePoints, crossing)">
                                Etapa vizată: {{licensePointConsequenceTargetLabel(licensePointConsequenceForCrossing(selectedLicensePointDriver.licensePoints, crossing).targetEvent)}}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action class="flex-row align-center">
                              <v-chip x-small :class="['license-point-status-chip', licensePointConsequenceStatusClass(licensePointCrossingStatus(selectedLicensePointDriver.licensePoints, crossing))]">
                                {{licensePointConsequenceStatusLabel(licensePointCrossingStatus(selectedLicensePointDriver.licensePoints, crossing))}}
                              </v-chip>
                              <v-chip
                                v-if="licensePointConsequenceTargetPassed(licensePointConsequenceForCrossing(selectedLicensePointDriver.licensePoints, crossing))"
                                x-small
                                class="ml-2 license-point-status-chip license-point-status-chip--overdue"
                              >ETAPĂ DEPĂȘITĂ</v-chip>
                              <v-chip v-if="!crossing.valid && licensePointConsequenceForCrossing(selectedLicensePointDriver.licensePoints, crossing)" x-small class="ml-2 license-point-history-chip--superseded">recalculat</v-chip>
                              <v-menu v-if="isAdministrator && crossing.valid" offset-y left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon small class="ml-1" v-bind="attrs" v-on="on" aria-label="Acțiuni consecință"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
                                </template>
                                <v-list dense>
                                  <v-list-item @click="requestLicensePointConsequenceConfirmation(crossing, 'PENDING')"><v-list-item-title>În aplicare</v-list-item-title></v-list-item>
                                  <v-list-item @click="requestLicensePointConsequenceConfirmation(crossing, 'SERVED')"><v-list-item-title>Executată</v-list-item-title></v-list-item>
                                  <v-list-item @click="requestLicensePointConsequenceConfirmation(crossing, 'CANCELLED')"><v-list-item-title>Anulată</v-list-item-title></v-list-item>
                                </v-list>
                              </v-menu>
                            </v-list-item-action>
                          </v-list-item>
                          </v-list>
                        </template>
                      </v-card-text>
                      <v-card-actions><v-spacer></v-spacer><v-btn text @click="licensePointDialog = false">Închide</v-btn></v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="licensePointConsequenceConfirmation" max-width="460" persistent>
                    <v-card>
                      <v-card-title>Confirmare consecință</v-card-title>
                      <v-card-text v-if="pendingLicensePointCrossing">
                        Vei înregistra pentru <strong>{{selectedLicensePointDriver.driverName}}</strong>
                        consecința „<strong>{{licensePointThresholdLabel(pendingLicensePointCrossing.thresholdType)}}</strong>”
                        cu starea „<strong>{{licensePointConsequenceStatusLabel(pendingLicensePointConsequenceStatus)}}</strong>”. Această acțiune oficializează decizia,
                        dar nu blochează automat pilotul de la calificări sau cursă (punerea in aplicare va ramane in sarcina organizatorilor).
                        <v-select
                          v-if="pendingLicensePointConsequenceStatus !== 'CANCELLED'"
                          v-model="licensePointConsequenceTargetEvent"
                          :items="licensePointTargetEvents"
                          item-text="title"
                          item-value="_id"
                          label="Etapa vizată (opțional)"
                          clearable
                          dense
                          outlined
                          hide-details
                          class="mt-4"
                        ></v-select>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text :disabled="licensePointConsequenceSaving" @click="cancelLicensePointConsequenceConfirmation">CANCEL</v-btn>
                        <v-btn color="primary" text :loading="licensePointConsequenceSaving" @click="confirmLicensePointConsequence">OK</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-container>
              </v-tab-item>
              <v-tab-item value="results">
                <v-container fluid class="pa-2">
                  <v-row align="center" dense>
                    <v-col
                      cols="12"
                      align="center"
                      class="py-1"
                    >
                      <v-btn-toggle
                        color="primary"
                        borderless
                        mandatory
                        v-model="storedResultsSession"
                      >
                        <v-btn
                          v-for="session in officialSessions"
                          :value="session._id"
                          :key="session._id"
                          @click="sessionresults = session._id"
                        >{{session.title}}</v-btn>
                      </v-btn-toggle>
                    </v-col>
                  </v-row>
                  <v-row align="center" dense>
                    <v-col
                      v-if="currentSession && currentSession.results && currentSession.results.length"
                      cols="12"
                      sm="6"
                      md="4"
                      class="py-1"
                    >
                      <v-select
                        dense
                        hide-details
                        :items="filterableCarClasses"
                        v-model="resultsSelectedCarClass"
                        label="Clasa"
                        item-text="name"
                        item-value="_id"
                      >
                        <template v-slot:selection="{ item }">
                          <kbd class="mr-1">{{item.acronym}}</kbd>
                        </template>

                        <template v-slot:item="{item, attrs, on}">
                          <v-list-item v-on="on" v-bind="attrs">
                            <v-list-item-content>
                              <v-list-item-title>
                                <v-row no-gutters align="center">
                                  <span>{{item.name}}</span>
                                  <v-spacer></v-spacer>
                                  <kbd class="mr-1">{{item.acronym}}</kbd>
                                </v-row>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                      v-if="canUserEditResults"
                      cols="12"
                      :sm="currentSession && currentSession.results && currentSession.results.length ? 6 : 12"
                      :md="currentSession && currentSession.results && currentSession.results.length ? 8 : 12"
                      class="py-1"
                      :align="sessionHashmap[sessionresults] && !sessionHashmap[sessionresults].results.length ? 'center' : 'right'"
                    >
                      <v-btn
                        color="primary"
                        :href="`/edit-session-results/${event._id}/${sessionresults}`"
                      >
                        <span v-if="currentSession && currentSession.results && !currentSession.results.length"><v-icon left>mdi-upload</v-icon>Încarcă rezultate</span>
                        <span v-else><v-icon left>mdi-file-edit</v-icon>Editează rezultate</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="currentSession && currentSession.results && currentSession.results.length">
                    <v-col>
                      <v-data-table
                        class="race-results-table"
                        :headers="isRaceSession ? computedRaceEventResultsTableHeaders : computedHotlapEventResultsTableHeaders"
                        :items="currentSession.results"
                        :group-by="event.results && event.results.length && event.results[0].Cursa ? 'Cursa' : null"
                        disable-pagination
                        hide-default-footer
                        :header-props="{ 'disable-sort': true }"
                      >
                        <!-- RO afisajul rezultatelor -->
                        <template v-slot:[`item.finalOverallResult`]="{ item }">
                          <v-icon color="yellow accent-4" v-if="item.finalOverallResult == 1">mdi-trophy</v-icon>
                          <v-icon color="grey lighten-1" v-else-if="item.finalOverallResult == 2">mdi-trophy-variant</v-icon>
                          <v-icon color="brown lighten-2" v-else-if="item.finalOverallResult == 3">mdi-trophy-variant</v-icon>
                          <span class="font-weight-black" v-else>{{item.finalOverallResult}}</span>
                        </template>
<!-- ======================NOOB ZONE============================= -->
                        <template v-slot:[`item.car_icon_results`]="{ item }">                          
                          <v-img
                            class="result-livery"
                            v-if="carHasLiveryPreview(item.eventRsvp.car.raceNumber)"
                            :src="carLiveryPreviewURL(item.eventRsvp.car.raceNumber)"
                            @error="handleCarLiveryError(item.eventRsvp.car.raceNumber)"
                          width="100%"
                          max-width="100"
                          height="40"
                          />
                        </template>
<!-- ===================NOOB ZONE================================ -->
                        <template v-slot:[`item.car`]="{ item }">
                          {{item.eventRsvp.car.carModel.title}}
                        </template>

                        <template v-slot:[`item.team`]="{ item }">
                          {{item.team.name}}
                        </template>
                        
                        <template v-slot:[`item.numberOfLaps`]="{ item }">
                          <v-dialog
                            v-model="carLapsDialog[item.finalOverallResult-1]"
                            max-width="700"
                            @click:outside="carLapsDialog[item.finalOverallResult-1] = false"
                            scrollable
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn min-width="32" class="px-1" text color="primary" v-on="on"><v-icon>mdi-timer</v-icon>{{item.laps.length}}</v-btn>
                            </template>
                            
                            <v-card class="pb-1">
                              <v-card-title>
                                <span class="headline">#{{ item.eventRsvp.car.raceNumber }} {{item.eventRsvp.car.carName}}</span>
                              </v-card-title>
                              <v-card-subtitle>
                                <span>Tururi</span>
                              </v-card-subtitle>
                              
                              <v-card-text style="max-height: 700px">
                                <v-data-table
                                  :headers="[
                                    {text:'#',value:'index',sortable:false,width:'5%'},
                                    {text:'Pilot',value:'driver',sortable:false,width:'45%'},
                                    {text:'Timp',value:'time',sortable:false,width:'45%'},
                                    {text:'Valid',value:'valid',sortable:false,width:'5%'}
                                  ]"
                                  :items="item.laps"
                                  disable-pagination
                                  hide-default-footer
                                  dense
                                >
                                  <template v-slot:item="{item, index}">
                                    <tr>
                                      <td>{{index + 1 }}</td>
                                      <td>{{ item.driver.profile.firstName }} {{ item.driver.profile.lastName }}</td>
                                      <td>{{ printLaptime (item.time) }}</td>
                                      <td>
                                        <v-icon color="green" v-if="item.valid">mdi-check</v-icon>
                                        <v-icon color="red" v-else>mdi-close</v-icon>
                                      </td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:[`item.totalTime`]="{ item }">
                          <span>
                            {{printRaceResultTime (item.totalTime)}}
                            <span v-if="item.dns">
                              (<strong class="orange--text">DNS</strong>)
                            </span>
                            <span v-else-if="item.dnf">
                              (<strong class="orange--text text--darken-2">DNF</strong>)
                            </span>
                            <span v-else-if="item.dsq">
                              (<strong class="red--text">DSQ</strong>)
                            </span>
                            <span v-else-if="item.timePenalties.length>0">
                              (<strong class="red--text">+{{item.timePenalties.reduce((a,b) => a+b.amount, 0)}}s</strong>)
                            </span>
                          </span>
                        </template>
                        <template v-slot:[`item.crew`]="{ item }">
                          <div class="crew-alignment">
                            <kbd
                              v-for="(carClass, kindex) in item.eventRsvp.car.classes"
                              :key="kindex"
                              class="mr-1 driver-class"
                              :class="{ 'driver-class--secondary': kindex > 0 }"
                              :style="{
                                backgroundColor: carClass.backgroundColor || '#424242',
                                color: carClass.textColor || '#ffffff'
                              }"
                            >
                              {{carClass.acronym}}
                            </kbd>
                            <span class="race-number">#{{ item.eventRsvp.car.raceNumber }}</span>

                            <span v-if="isTeamRace">{{item.eventRsvp.car.carName}}</span>
                            <span v-if="isTeamRace" class="crew-line-break" aria-hidden="true"></span>

                            <span class="driver-result-entry" :key="driver._id" v-for="(driver, index) in item.drivers">
                            <kbd 
                              v-for="(driverClass, kindex) in getUserClasses(driver._id)" 
                              :key="kindex" 
                              class="mr-1 driver-class"
                              :class="{ 'driver-class--secondary': kindex > 0 }"
                                :style="{
                                backgroundColor: driverClass.backgroundColor || '#424242',
                                color: driverClass.textColor || '#ffffff'
                                }"
                            >
                              {{driverClass.acronym}}
                            </kbd>
                            <router-link
                              v-if="isLoggedIn"
                              class="driver-profile-link"
                              :to="`/driver-profile/${driver._id}`"
                              :title="`Vezi profilul lui ${driver.profile.firstName} ${driver.profile.lastName}`"
                              :aria-label="`Vezi profilul lui ${driver.profile.firstName} ${driver.profile.lastName}`"
                            >{{driver.profile.firstName.slice(0, 1)}}. {{driver.profile.lastName}}<v-icon x-small>mdi-account-circle-outline</v-icon></router-link>
                            <template v-else>
                              {{driver.profile.firstName.slice(0, 1)}}. {{driver.profile.lastName}}
                            </template>
                              <span v-if="index < item.drivers.length - 1">, </span>
                            </span>
                          </div>
                        </template>
                        <template v-slot:[`item.fastestLap`]="{ item }">
                          <span class="font-weight-bold">{{printBestLaptime (item.laps)}}</span> <span v-if="item.drivers.length > 1">({{printBestLaptimeDriver(item.laps)}})</span>
                        </template>
                        <template v-slot:[`item.rlrRating`]="{ item }">
                          <div
                            v-for="driver in item.drivers"
                            :key="driver._id"
                            class="rlr-result-entry"
                          >
                            <span v-if="item.drivers.length > 1" class="text-caption text--secondary mr-1">
                              {{driver.profile.firstName.slice(0, 1)}}. {{driver.profile.lastName}}
                            </span>
                            <span v-if="item.dns" class="orange--text font-weight-bold">DNS</span>
                            <template v-else-if="item.rlrRatingByDriver && item.rlrRatingByDriver[driver._id]">
                              <strong>{{item.rlrRatingByDriver[driver._id].ratingAfter}}</strong>
                              <v-chip
                                x-small
                                label
                                dark
                                class="ml-1 rlr-result-change"
                                :color="rlrRatingChangeColor(item.rlrRatingByDriver[driver._id].change)"
                              >
                                {{signedRlrRatingChange(item.rlrRatingByDriver[driver._id].change)}}
                              </v-chip>
                            </template>
                            <span v-else>—</span>
                          </div>
                        </template>
                        <template v-slot:[`item.licensePoints`]="{ item }">
                          <div v-if="item.licensePointsByDriver">
                            <div v-for="driver in item.drivers" :key="driver._id">
                              <span>{{driver.profile.firstName.slice(0, 1)}}. {{driver.profile.lastName}}: +{{item.licensePointsByDriver[driver._id] || 0}} LP</span>
                            </div>
                          </div>
                        </template>
                        <template v-slot:[`item.penalties`]="{ item }">
                        <template v-if="item.dns">
                          <span class="orange--text font-weight-bold text-uppercase">DNS</span>
                        </template>
                        <template v-else-if="item.dnf">
                          <span class="orange--text text--darken-2 font-weight-bold text-uppercase">DNF</span>
                        </template>
                        <template v-else-if="item.dsq">
                          <span class="red--text font-weight-bold text-uppercase">DSQ</span>
                        </template>
                        <template v-else-if="item.timePenalties.length + item.lapPenalties.length + item.gridPenalties.length == 0">
                          <v-btn min-width="32" class="px-1" text tile color="primary" disabled><v-icon>mdi-clipboard-text-off</v-icon>
                            {{item.timePenalties.length + item.lapPenalties.length + item.gridPenalties.length}}
                          </v-btn>
                        </template>
                          <v-dialog
                            v-model="carPenaltiesDialog[item.finalOverallResult-1]"
                            max-width="600"
                            @click:outside="carPenaltiesDialog[item.finalOverallResult-1] = false"
                            scrollable
                            v-else
                          >
                            <template v-slot:activator="{ on }">
                              <template v-if="item.timePenalties.length + item.lapPenalties.length + item.gridPenalties.length > 0">
                                <v-btn min-width="32" class="px-1" text tile color="red" v-on="on"><v-icon>mdi-clipboard-text</v-icon>{{item.timePenalties.length + item.lapPenalties.length + item.gridPenalties.length}}</v-btn>
                              </template>
                              <template v-else>
                                <v-btn min-width="32" class="px-1" text tile color="primary" v-on="on"><v-icon>mdi-clipboard-text</v-icon>0</v-btn>
                              </template>
                            </template>
                            <v-card class="pb-1">
                              <v-card-title
                                ><span class="headline">#{{ item.eventRsvp.car.raceNumber }} {{item.eventRsvp.car.carName}}</span></v-card-title
                              >
                              <v-card-subtitle>
                                <span>Penalizări</span>
                              </v-card-subtitle>
                              
                              <v-card-text style="max-height: 700px">
                                <v-row class="mx-1" dense v-if="isRaceSession">
                                  <v-col
                                    cols="12"
                                  >
                                    <v-card elevation="0" outlined v-if="item.timePenalties.length > 0">
                                      <v-card-title class="text-h6 font-weight-regular">Penalizări în timp</v-card-title>
                                      <v-list>
                                        <v-list-item v-for="(penalty, i) in item.timePenalties" :key="i">
                                          <v-list-item-action>
                                            <span class="red--text text-h6"><v-icon small left color="red">mdi-clock-plus-outline</v-icon>{{ penalty.amount }}s</span>
                                          </v-list-item-action>
                                          <v-list-item-content>
                                            <span>{{penalty.description}} ({{penalty.driver.profile.firstName}} {{penalty.driver.profile.lastName}})</span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-card>
                                    <v-card elevation="0" outlined v-if="item.lapPenalties.length > 0">
                                      <v-card-title class="text-h6 font-weight-regular">Penalizări în tururi</v-card-title>
                                      <v-list>
                                        <v-list-item v-for="(penalty, i) in item.lapPenalties" :key="i">
                                          <v-list-item-action>
                                            <span class="red--text text-h6"><v-icon small left color="red">mdi-flag-minus</v-icon>{{ penalty.amount }}</span>
                                          </v-list-item-action>
                                          <v-list-item-content>
                                            <span>{{penalty.description}} ({{penalty.driver.profile.firstName}} {{penalty.driver.profile.lastName}})</span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-card>
                                    <v-card elevation="0" outlined v-if="item.gridPenalties.length > 0">
                                      <v-card-title class="text-h6 font-weight-regular">Penalizări în poziții</v-card-title>
                                      <v-list>
                                        <v-list-item v-for="(penalty, i) in item.gridPenalties" :key="i">
                                          <v-list-item-action>
                                            <span class="red--text text-h6"><v-icon small left color="red">mdi-chevron-triple-down</v-icon>{{ penalty.amount }}</span>
                                          </v-list-item-action>
                                          <v-list-item-content>
                                            <span>{{penalty.description}} ({{penalty.driver.profile.firstName}} {{penalty.driver.profile.lastName}})</span>
                                          </v-list-item-content>
                                        </v-list-item>
                                      </v-list>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import axios from '@/plugins/axios';
import IRacingPrequalAdmin from '@/components/IRacingPrequalAdmin.vue';

export default {
  components: {IRacingPrequalAdmin},
  data: () => {
    return {
      carLiveryFallbacks: {},
      carLiveryHidden: {},
      eventResultsLeaderLaps: 0,
      filteredEntrylist: [],
      resultsSelectedCarClass: null,
      licensePointDialog: false,
      selectedLicensePointDriver: null,
      licensePointConsequenceConfirmation: false,
      pendingLicensePointCrossing: null,
      pendingLicensePointConsequenceStatus: null,
      licensePointConsequenceTargetEvent: null,
      licensePointConsequenceSaving: false,
      licensePointRolesLoaded: false,
      seasonRegistrationsTableHeaders: [
        { text: "#", value: "position", sortable: false, width: "5%" },
        { text: "Echipaj", value: "carName", sortable: false, width: "14%" },
        { text: "Piloți", value: "drivers", sortable: false, width: "24%" },
        { text: "Best Lap", value: "bestLap", sortable: false, width: "12%", align: 'center' },
        { text: "Mașina", value: "carModel", sortable: false, width: "18%" },
        { text: "Rezultat / Tururi", value: "prettyPrequalTime", sortable: false, width: "11%", align: 'center' },
        { text: "Diferența", value: "leaderGap", sortable: false, width: "8%", align: 'center' },
        { text: "Prezență", value: "rsvpStatus", sortable: false, width: "8%" },
      ],
      carPenaltiesDialog: [],
      carLapsDialog: [],
      seasonRegistrationsTableData: [],
      rsvpDialogCar: undefined,
      rsvpCar: undefined,
      firstDriver: undefined,
      userAvailableCars: [],
      rsvpDialog: false,
      rsvpOpen: false,
      driverSuspended: false,
      rsvpDateGood: false,
      driverInRegisteredCar: false,
      prequalHashMap: {},
      bestPrequalTime: 0,
      bestPrequalTimeCar: '',
      carInfoDialog: {},
      DRIVER_STATUS_UNKNOWN: 0,
      DRIVER_STATUS_GREEN: 1,
      DRIVER_STATUS_TIME: 2,
      DRIVER_STATUS_RED: 3,
      DRIVER_STATUS_SUSPENDED: 4,
      DRIVER_STATUS_WILDCARD: 5,
      CAR_STATUS_UNKNOWN: 0,
      CAR_STATUS_GREEN: 1,
      CAR_STATUS_TIME: 2,
      CAR_STATUS_RED: 3,
      CAR_STATUS_SUSPENDED: 4,
      CAR_STATUS_WILDCARD: 5,
      sessionHashmap: {},
      storedResultsSession: undefined,
      currentSession: {
        type: { code: 'P' },
        results: []
      }
    };
  },
  methods: {
    ...mapActions("event", ["getEvent", "getEntrylist"]),
    ...mapActions("season", ["getSeason", "getUserSeasonClasses"]),
    ...mapActions("user", ["getUserPermissions", "getUserRoles"]),
    ...mapActions("app", ["showSnackbar"]),
    driverAvatarUrl (driver) {
      const picture = driver && driver.user && driver.user.profile
        ? driver.user.profile.profilePicture
        : null;

      if (!picture || !picture.filename) {
        return '';
      }

      return `${process.env.VUE_APP_API_SCHEMA}${process.env.VUE_APP_API_HOST}/api/files/${picture.filename}`;
    },
    prequalDriverSubtitle (entry) {
      return this.season.prequalDriverSubtitle === 'team'
        ? entry.car.carName
        : entry.clubName;
    },
    openLicensePointDialog (driver) {
      this.selectedLicensePointDriver = driver;
      this.licensePointDialog = true;
    },
    refreshSelectedLicensePointDriver () {
      if (!this.selectedLicensePointDriver) return;
      const selectedId = this.selectedLicensePointDriver.user._id.toString();
      for (const entry of this.filteredEntrylist) {
        const driver = (entry.drivers || []).find(item => item.user._id.toString() === selectedId);
        if (driver) {
          this.selectedLicensePointDriver = driver;
          return;
        }
      }
      this.licensePointDialog = false;
      this.selectedLicensePointDriver = null;
    },
    licensePointThresholdLabel (threshold) {
      return {
        QUALIFYING_BAN: 'prag calificări',
        RACE_BAN: 'prag suspendare',
        SEASON_ELIMINATION: 'prag eliminare'
      }[threshold] || threshold || 'fără prag';
    },
    licensePointThresholdColor (threshold) {
      return {
        QUALIFYING_BAN: 'orange darken-2',
        RACE_BAN: 'deep-orange darken-2',
        SEASON_ELIMINATION: 'red darken-3'
      }[threshold] || 'grey lighten-2';
    },
    licensePointChipClass (threshold) {
      return {
        QUALIFYING_BAN: 'license-points-chip--qualifying',
        RACE_BAN: 'license-points-chip--race-ban',
        SEASON_ELIMINATION: 'license-points-chip--elimination'
      }[threshold] || 'license-points-chip--neutral';
    },
    licensePointConsequenceStatusLabel (status) {
      return {NEW: 'NOU', PENDING: 'ÎN APLICARE', SERVED: 'EXECUTATĂ', CANCELLED: 'ANULATĂ', RECALCULATED: 'RECALCULATĂ'}[status] || status;
    },
    licensePointConsequenceStatusClass (status) {
      return {
        NEW: 'license-point-status-chip--new',
        PENDING: 'license-point-status-chip--pending',
        SERVED: 'license-point-status-chip--served',
        CANCELLED: 'license-point-status-chip--cancelled',
        RECALCULATED: 'license-point-status-chip--cancelled'
      }[status] || 'license-point-status-chip--cancelled';
    },
    licensePointConsequenceTargetLabel (targetEvent) {
      if (!targetEvent) return 'nespecificată';
      const targetId = (targetEvent._id || targetEvent).toString();
      const event = this.licensePointTargetEvents.find(item => item._id.toString() === targetId);
      return event ? event.title : 'etapă indisponibilă';
    },
    licensePointCrossingEventLabel (crossingEvent) {
      if (!crossingEvent) return 'soldul inițial';
      const eventId = (crossingEvent._id || crossingEvent).toString();
      const event = this.licensePointTargetEvents.find(item => item._id.toString() === eventId);
      return event ? event.title : 'o etapă indisponibilă';
    },
    licensePointCleanRewardRemainingLabel (progress) {
      const required = this.event.season.rules.licensePoints.cleanRoundsRequired;
      const remaining = Math.max(1, required - progress);
      return remaining === 1
        ? 'după următoarea etapă curată'
        : `după încă ${remaining} etape curate`;
    },
    licensePointConsequenceForCrossing (points, crossing) {
      return (points.consequences || []).find(consequence => {
        return consequence.crossing && consequence.crossing.toString() === crossing._id.toString();
      }) || null;
    },
    activeLicensePointConsequences (driver) {
      if (!driver || !driver.licensePoints) return [];
      return (driver.licensePoints.consequences || []).filter(consequence => consequence.status === 'PENDING');
    },
    licensePointDecisionIndicatorClass (driver) {
      const priorities = {QUALIFYING_BAN: 1, RACE_BAN: 2, SEASON_ELIMINATION: 3};
      const highest = this.activeLicensePointConsequences(driver).reduce((selected, consequence) => {
        return !selected || (priorities[consequence.type] || 0) > (priorities[selected.type] || 0)
          ? consequence
          : selected;
      }, null);
      return {
        QUALIFYING_BAN: 'license-point-decision-indicator--qualifying',
        RACE_BAN: 'license-point-decision-indicator--race-ban',
        SEASON_ELIMINATION: 'license-point-decision-indicator--elimination'
      }[highest && highest.type] || 'license-point-decision-indicator--qualifying';
    },
    licensePointConsequenceTargetPassed (consequence) {
      if (!consequence || consequence.status !== 'PENDING' || !consequence.targetEvent) return false;
      const targetId = (consequence.targetEvent._id || consequence.targetEvent).toString();
      const targetEvent = this.licensePointTargetEvents.find(event => event._id.toString() === targetId);
      if (!targetEvent || !targetEvent.time) return false;
      return new Date(targetEvent.time).getTime() < Date.now();
    },
    licensePointCrossingStatus (points, crossing) {
      const consequence = this.licensePointConsequenceForCrossing(points, crossing);
      if (consequence) return consequence.status;
      return crossing.valid ? 'NEW' : 'RECALCULATED';
    },
    requestLicensePointConsequenceConfirmation (crossing, status) {
      this.pendingLicensePointCrossing = crossing;
      this.pendingLicensePointConsequenceStatus = status;
      const consequence = this.licensePointConsequenceForCrossing(this.selectedLicensePointDriver.licensePoints, crossing);
      this.licensePointConsequenceTargetEvent = status === 'CANCELLED'
        ? null
        : consequence
        ? consequence.targetEvent
        : this.suggestedLicensePointTargetEvent(crossing);
      this.licensePointConsequenceConfirmation = true;
    },
    suggestedLicensePointTargetEvent (crossing) {
      if (crossing.thresholdType === 'SEASON_ELIMINATION') return null;
      const crossingEventId = crossing.event && (crossing.event._id || crossing.event).toString();
      if (!crossingEventId) return this.licensePointTargetEvents.length ? this.licensePointTargetEvents[0]._id : null;
      const crossingIndex = this.licensePointTargetEvents.findIndex(event => event._id.toString() === crossingEventId);
      const nextEvent = crossingIndex >= 0 ? this.licensePointTargetEvents[crossingIndex + 1] : null;
      return nextEvent ? nextEvent._id : null;
    },
    cancelLicensePointConsequenceConfirmation () {
      this.licensePointConsequenceConfirmation = false;
      this.pendingLicensePointCrossing = null;
      this.pendingLicensePointConsequenceStatus = null;
      this.licensePointConsequenceTargetEvent = null;
    },
    async confirmLicensePointConsequence () {
      if (!this.selectedLicensePointDriver || !this.pendingLicensePointCrossing) return;
      this.licensePointConsequenceSaving = true;
      const saved = await this.saveLicensePointConsequence(
        this.selectedLicensePointDriver,
        this.pendingLicensePointCrossing,
        this.pendingLicensePointConsequenceStatus
      );
      this.licensePointConsequenceSaving = false;
      if (saved) this.cancelLicensePointConsequenceConfirmation();
    },
    async saveLicensePointConsequence (driver, crossing, status) {
      const existing = this.licensePointConsequenceForCrossing(driver.licensePoints, crossing);
      try {
        await axios({
          url: existing
            ? `/api/season/${this.event.season._id}/license-points-consequences/${existing._id}`
            : `/api/season/${this.event.season._id}/license-points-consequences`,
          method: 'POST',
          data: existing ? {
            status,
            targetEvent: this.licensePointConsequenceTargetEvent || null,
            note: existing.note || ''
          } : {
            driver: driver.user._id,
            crossing: crossing._id,
            type: crossing.thresholdType,
            status,
            targetEvent: this.licensePointConsequenceTargetEvent || null
          }
        });
        await this.updateSeasonRegistrationsTableData();
        this.refreshSelectedLicensePointDriver();
        this.showSnackbar({timeout: 4000, content: 'Decizia pentru prag a fost salvată.', color: 'success', value: true});
        return true;
      } catch (error) {
        this.showSnackbar({timeout: 7000, content: 'Consecința nu a putut fi salvată.', color: 'error', value: true});
        return false;
      }
    },
    async addLicensePointAdjustment (driver) {
      const pointsText = window.prompt('Corecție LP (număr întreg pozitiv sau negativ):');
      if (pointsText === null) return;
      const points = Number(pointsText);
      if (!Number.isInteger(points) || points === 0) {
        this.showSnackbar({timeout: 5000, content: 'Corecția trebuie să fie un număr întreg diferit de zero.', color: 'error', value: true});
        return;
      }
      const description = window.prompt('Motivul corecției:');
      if (!description || !description.trim()) return;
      try {
        await axios({
          url: `/api/season/${this.event.season._id}/license-points-adjustment`,
          method: 'POST',
          data: {driver: driver.user._id, event: this.event._id, points, description}
        });
        await this.updateSeasonRegistrationsTableData();
        this.refreshSelectedLicensePointDriver();
        this.showSnackbar({timeout: 4000, content: 'Corecția LP a fost salvată.', color: 'success', value: true});
      } catch (error) {
        this.showSnackbar({timeout: 7000, content: 'Corecția LP nu a putut fi salvată.', color: 'error', value: true});
      }
    },
    carModelTitleParts (title) {
      const parts = (title || '').trim().split(/\s+/);

      if (parts.length < 2) {
        return { make: '', model: parts[0] || '' };
      }

      return {
        make: parts[0],
        model: parts.slice(1).join(' ')
      };
    },
    prequalPositionClass (position) {
      return {
        1: 'prequal-mobile-position--first',
        2: 'prequal-mobile-position--second',
        3: 'prequal-mobile-position--third'
      }[position] || '';
    },
    hasValidPrequalResult (entry) {
      return entry && entry.prequal && Number.isFinite(entry.prequal.result)
        && entry.prequal.result > 0
        && entry.prequal.result < 2147483647;
    },
    hasValidBestLap (bestLapTime) {
      const lapTime = Number(bestLapTime);
      return Number.isFinite(lapTime) && lapTime > 0 && lapTime < 2147483647;
    },
    isFastestPrequalLap (bestLapTime) {
      return this.hasValidBestLap(bestLapTime) && Number(bestLapTime) === this.prequalFastestLapTime;
    },
    isPrequalLeader (entry) {
      return !!(this.prequalLeader && entry.car._id === this.prequalLeader.car._id);
    },
    printTimeDifference (time) {
      const minutes = Math.floor(time / 60000);
      const seconds = Math.floor(time / 1000) % 60;
      const milliseconds = time % 1000;
      const secondsText = minutes ? ("00" + seconds).slice(-2) : seconds;
      const millisecondsText = ("000" + milliseconds).slice(-3);

      return `${minutes ? `${minutes}:` : ''}${secondsText}.${millisecondsText}`;
    },
    rsvpCarChanged () {
      // Look for first driver in event cars:
      let found = false;
      if (!this.rsvpDialogCar) {
        this.firstDriver = undefined;
        return;
      }

      this.event.cars.forEach((ec) => {
        if (ec.car._id == this.rsvpDialogCar._id) {
          let rsvpStatus =
            ec.drivers.filter((ecd) => {
              return ecd.driver._id == this.userinfo.id && ecd.registrationStatus;
            }).length > 0;

          if (rsvpStatus) {
            found = true;
            this.firstDriver = ec.drivers[0].driver;
            return;
          }
        }
      })

      // Fallback to season registration driver order if there is no EventRSVP just yet.
      if ( !found ) {
        this.firstDriver = this.rsvpDialogCar.drivers[0].driver;
      }
    },
    resultsCarClassFilter (_, __, item) {
      if (!this.resultsSelectedCarClass) {
        return true;
      }

      return item.eventRsvp.car.classes.map(cls => cls._id.toString()).includes(this.resultsSelectedCarClass.toString());
    },
    signedRlrRatingChange (value) {
      const change = Number(value) || 0;
      return change > 0 ? `+${change}` : `${change}`;
    },
    rlrRatingChangeColor (value) {
      if (value > 0) return 'green';
      if (value < 0) return 'red accent-2';
      return 'grey';
    },
    shortRlrRating (value) {
      const rating = Number(value);
      if (!Number.isFinite(rating)) return '—';
      if (Math.abs(rating) < 1000) return `${Math.round(rating)}`;
      const shortened = Math.round(rating / 100) / 10;
      return `${shortened.toFixed(1)}k`;
    },
    driverRlrRatingValue (driver) {
      const rating = driver && driver.rlrRating && Number(driver.rlrRating.rating);
      return Number.isFinite(rating) ? rating : 2500;
    },
    utf8To16 (text) {
      var byteArray = new Uint8Array(text.length * 2);
      for (var i = 0; i < text.length; i++) {
          byteArray[i*2] = text.charCodeAt(i) // & 0xff;
          byteArray[i*2+1] = text.charCodeAt(i) >> 8 // & 0xff;
      }

      return byteArray;
    },
    downloadEntrylist() {
      try {
        switch ( this.event.season.rules.simulator.acronym ) {
          case 'AC':
            axios({
              url: `/api/event/${this.event._id}/ac-download-entrylist`,
              method: 'GET',
              responseType: 'text'
            }).then((response) => {
              let blob = new Blob([response.data], { type: 'text/plain' })
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              
              link.download = 'entry_list.ini';
              
              link.click();
            });
            break
          case 'ACC':
            axios({
              url: `/api/event/${this.event._id}/acc-download-entrylist`,
              method: 'GET',
              responseType: 'json'
            }).then((response) => {
              const utf16le = this.utf8To16(JSON.stringify(response.data, null, 4));

              let blob = new Blob([utf16le], { type: 'application/json' })
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              
              link.download = 'entrylist.json';
              
              link.click();
            });
            break
        }
      } catch {
        console.log ("Could not download entrylist :-(")
      }
    },
    getUserClasses(driverId) {
      if (this.userSeasonClasses) {
        return this.userSeasonClasses.filter(item => item.user == driverId).map(uc=>uc.classes).flat();
      }
      
      return [];
    },
    isUserWildcard(userId) {
      if ( this.event ) {
        return this.event.wildcards.includes(userId);
      }
      
      return false;
    },
    timelineColor (session) {
      switch (session.type.code) {
        case 'P': return 'light-blue darken-3'
        case 'Q': {
          return session.official ? 'deep-orange darken-4' : 'cyan darken-3'
        }
        case 'R': return 'green darken-3'
        case 'O':
        case 'A': return 'blue-grey darken-4'
      }
    },
    printDate(date) {
      let m = new Date(date);

      let result =
        m.getUTCFullYear() + "-" + ("00" + (m.getUTCMonth() + 1)).slice(-2) + "-" + ("00" + m.getUTCDate()).slice(-2);

      result += ", " + ("00" + m.getHours()).slice(-2) + ":" + ("00" + m.getMinutes()).slice(-2);

      return result;
    },

    carLiveryFileName (raceNumber) {
      const seasonPrefix = this.event.season.code ? `RLR_${this.event.season.code}` : 'RLR';
      return `${seasonPrefix}_${raceNumber}.png`;
    },

    carHasLiveryPreview (raceNumber) {
      return !!this.event.season.code && !this.carLiveryHidden[String(raceNumber)];
    },

    carLiveryPreviewURL (raceNumber) {
      const key = String(raceNumber);
      const displayedNumber = this.carLiveryFallbacks[key] ? '00' : raceNumber;
      return `/car_ico/${this.carLiveryFileName(displayedNumber)}?v=${this.event.season.carIconsVersion || 0}`;
    },

    handleCarLiveryError (raceNumber) {
      const key = String(raceNumber);
      if (!this.carLiveryFallbacks[key] && key !== '00') {
        this.$set(this.carLiveryFallbacks, key, true);
      } else {
        this.$set(this.carLiveryHidden, key, true);
      }
    },
    printLaptime(time) {
      if (time == 2147483647) {
        return "---";
      }

      let t = "";
      let minutes = Math.floor(time / 60000);
      // minutes = ("00"+(minutes)).slice(-2)

      let seconds = Math.floor(time / 1000) % 60;
      seconds = ("00" + seconds).slice(-2);

      let milliseconds = time % 1000;
      milliseconds = ("000" + milliseconds).slice(-3);

      t += minutes + ":" + seconds + "." + milliseconds;

      return t;
    },
    printRaceResultTime(time) {
      let t = "";

      let hours = Math.floor(time / 3600000);

      if (hours) {
        t += hours;
        t += ":";
      }

      let minutes = Math.floor(time / 60000) % 60;
      if (hours) {
        t += ("00" + minutes).slice(-2);
      } else {
        t += minutes;
      }

      t += ":";

      let seconds = Math.floor(time / 1000) % 60;
      t += ("00" + seconds).slice(-2);

      t += ".";

      let milliseconds = time % 1000;
      t += milliseconds = ("000" + milliseconds).slice(-3);

      return t;
    },
    printBestLaptime (laps) {
      return this.printLaptime(laps.reduce ((a, b) => a > b.time && b.valid ? b.time : a, 2147483647));
    },
    printBestLaptimeDriver (laps) {
      let driver = '';
      let bestlap = 2147483647;
      
      laps.forEach (lap => {
        if (lap.time < bestlap) {
          bestlap = lap.time;
          driver = lap.driver.profile.firstName.slice(0,1) + lap.driver.profile.lastName.slice(0,1);
        }
      })
      
      return driver;
    },
    updatePrequalHashMap() {
      if (!this.event.season.rules.prequalEnabled) {
        this.prequalHashMap = {};
      }

      this.event.prequal.results.forEach((result) => {
        this.prequalHashMap[`${result.driver}_${result.carModel}`] = result;
      });
    },
    showCar(car_id) {
      this.carInfoDialog[car_id] = true;
    },
    closeCar(car_id) {
      this.carInfoDialog[car_id] = false;
    },
    updateEventResultsTableData() {
      this.event.results = this.event.results.map((result) => {
        result.Cursa = result.race;
        return result;
      });
    },
    async refreshIracingResults() {
      await this.getEvent(this.event._id);
      this.prequalHashMap = {};
      this.updatePrequalHashMap();
      await this.updateSeasonRegistrationsTableData();
    },
    async updateSeasonRegistrationsTableData() {
      await this.getEntrylist(this.event._id);
      
      this.filteredEntrylist = [];
      this.carInfoDialog = {};
      
      this.entrylist.splits.forEach(split => {
        split.entries.forEach(entry => {
          entry.Split = split.title;
          this.filteredEntrylist.push(entry);
          this.carInfoDialog[entry.car._id] = false;
        })
      })
    },
    updateUserAvailableCars() {
      this.userAvailableCars = [];

      if (this.isLoggedIn) {
        this.event.season.registrations.forEach((registration) => {
          registration.cars.forEach((car) => {
            let carRegistrationStatus = car.drivers.reduce((a, c) => {
              return a && c.registrationStatus;
            });
            if (
              car.drivers
                .map((carDriver) => {
                  return carDriver.driver._id;
                })
                .includes(this.userinfo.id) &&
              carRegistrationStatus
            ) {
              this.userAvailableCars.push(car);
            }
          });
        });
      }
    },
    updateRSVPCar() {
      this.rsvpDialogCar = "";
      this.rsvpCar = "";

      if (this.isLoggedIn) {
        this.event.season.registrations.forEach((registration) => {
          registration.cars.forEach((c) => {
            c.drivers.forEach((carDriver) => {
              if (carDriver.driver._id == this.userinfo.id) {
                let rsvpStatus = false;

                this.event.cars.forEach((ec) => {
                  if (ec.car._id == c._id) {
                    rsvpStatus =
                      ec.drivers.filter((ecd) => {
                        return ecd.driver._id == this.userinfo.id && ecd.registrationStatus;
                      }).length > 0;

                    if (rsvpStatus) {
                      this.rsvpDialogCar = c;
                      this.rsvpCar = c;
                      this.rsvpCarChanged(); // Trigger first driver refresh
                      return;
                    }
                  }
                });
              }
            });

            if (this.rsvpCar) {
              return;
            }
          });

          if (this.rsvpCar) {
            return;
          }
        });
      }
    },
    async sendRSVP() {
      const carId = this.rsvpCar ? this.rsvpCar._id : "";
      const firstDriverId = this.firstDriver ? this.firstDriver._id : "";

      let newRSVP = await this.$http.post(`/api/event/${this.event._id}/rsvp`, {
        status: carId ? 'present' : 'absent',
        car: carId,
        firstDriver: firstDriverId
      });
      this.showSnackbar({
        timeout: 7000,
        content: newRSVP.data.data,
        color: newRSVP.data.status == "200" ? "success" : "error",
        value: true,
      });

      await this.getEvent(this.$route.params.id);
      await this.updateSeasonRegistrationsTableData();
    },
    resetRSVPCar() {
      this.rsvpCar = undefined;
      this.rsvpDialogCar = undefined;
      this.rsvpDialog = false;

      this.sendRSVP();
    },
    confirmRSVP() {
      this.rsvpCar = this.rsvpDialogCar;
      this.rsvpDialog = false;
      this.sendRSVP();
    },
    cancelRSVPDialog() {
      this.rsvpDialogCar = this.rsvpCar;
      this.rsvpDialog = false;
    },
    driverRSVPColor(status) {
      return {
        present: 'green',
        absent: 'red',
        other_car: 'blue',
        unanswered: 'grey'
      }[status] || 'grey';
    },
    driverRSVPIcon(status) {
      return {
        present: 'mdi-clipboard-check-outline',
        absent: 'mdi-clipboard-remove-outline',
        other_car: 'mdi-car-arrow-right',
        unanswered: 'mdi-clipboard-alert-outline'
      }[status] || 'mdi-clipboard-alert-outline';
    },
    driverRSVPLabel(driver) {
      if (driver.rsvpResponseStatus == 'present') {
        return 'Prezență confirmată';
      }
      if (driver.rsvpResponseStatus == 'absent') {
        return 'Absent';
      }
      if (driver.rsvpResponseStatus == 'other_car') {
        const raceNumber = driver.rsvpSelectedCar && driver.rsvpSelectedCar.raceNumber;
        return raceNumber ? `Participă cu #${raceNumber}` : 'Participă cu altă mașină';
      }
      return 'Nu a răspuns';
    },
    teamRSVPLabel(status) {
      return {
        confirmed: 'Prezența echipajului este confirmată',
        absent: 'Cel puțin un pilot este absent',
        other_car: 'Cel puțin un pilot participă cu altă mașină',
        unanswered: 'Se așteaptă răspunsuri de la piloți'
      }[status] || 'Se așteaptă răspunsuri de la piloți';
    },
    entryStatusColor(item) {
      if (item.status == this.CAR_STATUS_SUSPENDED) {
        return 'red';
      }
      if (item.status == this.CAR_STATUS_TIME) {
        return 'yellow darken-3';
      }
      return {
        confirmed: 'green',
        absent: 'red',
        other_car: 'blue',
        unanswered: 'grey lighten-1'
      }[item.rsvpTeamStatus] || 'grey';
    },
    entryStatusIcon(item) {
      if (item.status == this.CAR_STATUS_SUSPENDED) {
        return 'mdi-cancel';
      }
      if (item.status == this.CAR_STATUS_TIME) {
        return 'mdi-timer-off-outline';
      }
      return {
        confirmed: 'mdi-check-circle',
        absent: 'mdi-account-off',
        other_car: 'mdi-car-arrow-right',
        unanswered: 'mdi-help-circle-outline'
      }[item.rsvpTeamStatus] || 'mdi-help-circle-outline';
    },
    entryStatusLabel(item) {
      if (item.status == this.CAR_STATUS_SUSPENDED) {
        return 'Suspendat';
      }
      if (item.status == this.CAR_STATUS_TIME) {
        return 'Nu îndeplinește baremul de precalificare';
      }
      return this.teamRSVPLabel(item.rsvpTeamStatus);
    },
    updateRSVPOpen() {
      const rsvpStart = new Date(this.event.rsvpStart);
      const rsvpEnd = new Date(this.event.rsvpEnd);
      const dateCriteria = rsvpStart < Date.now() && rsvpEnd > Date.now();

      this.rsvpDateGood = dateCriteria;
      let driverCriteria = false;

      this.event.season.registrations.forEach((registration) => {
        registration.cars.forEach((car) => {
          let carRegistrationStatus = car.drivers.reduce((a, c) => {
            return a && c.registrationStatus;
          });
          if (
            car.drivers
              .map((carDriver) => {
                return carDriver.driver._id;
              })
              .includes(this.userinfo.id) &&
            carRegistrationStatus
          ) {
            driverCriteria = true;
          }
        });
      });

      this.rsvpOpen = dateCriteria && driverCriteria && !this.driverSuspended;
      this.driverInRegisteredCar = driverCriteria;
    },
    //--------------LUC
    getLapPercentage(validLaps, totalLaps) {
      if (validLaps === undefined || validLaps === null || !totalLaps) {
        return '—';
      }
      const percentage = Math.round((validLaps / totalLaps) * 100);
      return percentage + '%';
    }
    //-------------LUC
  },
  computed: {
    ...mapState("event", ["event", "entrylist"]),
    ...mapState("season", ["season", "userSeasonClasses"]),
    ...mapGetters("user", ["userPermissions", "userRoles"]),
    isAdministrator () {
      return this.licensePointRolesLoaded && this.userRoles.some(role => role && role.name === 'Administrator');
    },
    ...mapGetters("auth", ["userinfo", "isLoggedIn"]),
    isTeamRace () {
      return !!(this.season?.rules?.maxDriversPerCar > 1)
    },
      isPrequalEnabled () {
        return !!this.season?.rules?.prequalEnabled
      },
      licensePointThresholds () {
        const thresholds = this.event.season.rules.licensePoints.thresholds;
        return [
          {type: 'QUALIFYING_BAN', value: thresholds.qualifyingBan, description: 'Organizatorii pot aplica interdicția de participare la calificări.'},
          {type: 'RACE_BAN', value: thresholds.raceBan, description: 'Organizatorii pot aplica interdicția de participare la următoarea cursă.'},
          {type: 'SEASON_ELIMINATION', value: thresholds.seasonElimination, description: 'Organizatorii pot elimina pilotul din sezon.'}
        ];
      },
      licensePointTargetEvents () {
        return (this.season.events || []).slice().sort((first, second) => {
          return new Date(first.time).getTime() - new Date(second.time).getTime();
        });
      },
      prequalLastUpdatedAt () {
        const iracing = this.event && this.event.prequal
          ? this.event.prequal.iracing
          : null;
        return iracing ? iracing.lastSuccessfulImportAt || null : null;
      },
      prequalRequiredLaps () {
        const configuredLaps = Number(this.event && this.event.prequal && this.event.prequal.iracing
          ? this.event.prequal.iracing.averageLaps
          : 0);
        if (Number.isFinite(configuredLaps) && configuredLaps > 0) return Math.floor(configuredLaps);

        const sessions = this.event && this.event.sessions || [];
        const prequalSession = sessions.find(session => {
          return session && !session.official && session.type && session.type.code === 'Q';
        });
        const requiredLaps = Number(prequalSession && prequalSession.hotstintLaps);

        return Number.isFinite(requiredLaps) && requiredLaps > 1
          ? Math.floor(requiredLaps)
          : 1;
      },
      prequalResultCalculationLabel () {
        return this.prequalRequiredLaps > 1
          ? `Medie pe ${this.prequalRequiredLaps} tururi consecutive valide`
          : 'Cel mai bun tur';
      },
      prequalFastestLapTime () {
        let fastestLap = 2147483647;
        this.filteredEntrylist.forEach(entry => {
          const drivers = entry && entry.prequal ? entry.prequal.drivers || [] : [];
          drivers.forEach(driver => {
            const lapTime = Number(driver.bestLapTime);
            if (Number.isFinite(lapTime) && lapTime > 0 && lapTime < fastestLap) fastestLap = lapTime;
          });
        });
        return fastestLap < 2147483647 ? fastestLap : null;
      },
      prequalLeader () {
        return this.filteredEntrylist
          .filter(entry => entry.status === this.CAR_STATUS_GREEN
            && entry.rsvpTeamStatus === 'confirmed'
            && this.hasValidPrequalResult(entry))
          .sort((a, b) => a.position - b.position)[0] || null;
      },
      prequalRaceNumberWidth () {
        const maxDigits = this.filteredEntrylist.reduce((length, entry) => {
          const raceNumber = entry && entry.car ? String(entry.car.raceNumber || '') : '';
          return Math.max(length, raceNumber.length);
        }, 1);

        return `${maxDigits + 1}ch`;
      },
    computedSeasonRegistrationsTableHeaders () {
      return this.seasonRegistrationsTableHeaders.filter(header => {
        if (header.value === 'drivers' ) {
          return {...header, text: 'Pilot'}
        }

        return header
      }).filter(header => {
        if (header.value === 'prettyPrequalTime' || header.value === 'leaderGap' || header.value === 'bestLap') {
          return this.isPrequalEnabled
        }

        if (header.value === 'carName') {
          return this.isTeamRace
        }

        return true
      });
    },
    computedRaceEventResultsTableHeaders () {
      return this.raceEventResultsTableHeaders.filter(header => {
        if (header.value === 'licensePoints') {
          return !!(this.event.season.rules.licensePoints && this.event.season.rules.licensePoints.enabled)
        }
        if (header.value === 'rlrRating') {
          return this.currentSession.results.some(result => result.rlrRatingByDriver)
        }
        return true
      }).map(header => {
        if (header.value === 'crew') {
          return {...header, text: 'Pilot'}
        }

        return header
      })
    },
    computedHotlapEventResultsTableHeaders () {
      return this.hotlapEventResultsTableHeaders.map(header => {
        if (header.value === 'crew') {
          return {...header, text: 'Pilot'}
        }

        return header
      })
    },
    carNeedsFirstDriverSet () {
      const simulatorNeedsFirstDriverSet = this.event ? this.event.season.rules.simulator.acronym=='ACC' : false;
      const moreThanOneDriver = this.rsvpDialogCar && this.rsvpDialogCar.drivers ? this.rsvpDialogCar.drivers.length > 1 : false;

      return simulatorNeedsFirstDriverSet && moreThanOneDriver;
    },
    hasUserResponded() {
      if (!this.isLoggedIn || !this.event.rsvpResponses) {
        return false;
      }

      return this.event.rsvpResponses.some(response => response.driver == this.userinfo.id);
    },
    rsvpAvailableDrivers() {
      if (this.rsvpDialogCar && this.rsvpDialogCar.drivers) {
        return this.rsvpDialogCar.drivers.map(cd => cd.driver) || [];
      }

      return [];
    },
    filterableCarClasses() {
      return [{_id: null, acronym: 'O', name: 'Open'}, ...this.event.season.carClasses.map(cls => cls.obj)]
    },
//================NOOB====================================================================================
    raceEventResultsTableHeaders() {return [
      { text: "Poz.", value: "finalOverallResult", sortable: false, width: "5%", align: 'center' },
      { text: "", value: "car_icon_results", sortable: false, width: "10%", align: 'center'  },
      { text: "Echipaj", value: "crew", sortable: false, width: "22%", filter: this.resultsCarClassFilter },
      { text: "Timp total", value: "totalTime", sortable: false, width: "13%", align: 'center' },
      { text: "Tururi", value: "numberOfLaps", sortable: false, width: "8%", align: 'center' },
      { text: "Fastest lap", value: "fastestLap", sortable: false, width: "13%", align: 'center' },
      { text: "RLR Rating", value: "rlrRating", sortable: false, width: "12%", align: 'center' },
      { text: "Puncte licență", value: "licensePoints", sortable: false, width: "10%", align: 'center' },
      { text: "Penalizări (post-cursă)", value: "penalties", sortable: false, width: "7%", align: 'center' },
    ]},
    hotlapEventResultsTableHeaders() {return [
      { text: "Poz.", value: "finalOverallResult", sortable: false, width: "5%", align: 'center' },
      { text: "", value: "car_icon_results", sortable: false, width: "10%", align: 'center'  },
      { text: "Echipaj", value: "crew", sortable: false, width: "40%", filter: this.resultsCarClassFilter },
      { text: "Tururi", value: "numberOfLaps", sortable: false, width: "10%", align: 'center' },
      { text: "Fastest lap", value: "fastestLap", sortable: false, width: "30%", align: 'center' },
      { text: "Penalizări (post-cursă)", value: "penalties", sortable: false, width: "5%", align: 'center' },
    ]},
//===========================NOOOB========================================================================
    canUserEditResults () {
      if ( this.event.season && this.event.season.permissions && this.event.season.permissions.editRaceResults ) {
        return this.userPermissions.filter(perm => this.event.season.permissions.editRaceResults.includes(perm)).length>0;
      }
      
      return false;
    },
    canUserDownloadEntrylist () {
      const acceptableSimulators = [ "AC", "ACC" ]
      
      try {
        if (acceptableSimulators.indexOf ( this.event.season.rules.simulator.acronym ) === -1) {
          return false
        }
        
        return this.userPermissions.filter(perm => this.event.season.permissions.downloadEntrylists.includes(perm)).length>0;
      } catch (e) {
        console.log (e.message)
        return false
      }
    },
    isHotlapSession () {
      return this.currentSession.type.code == 'Q' || this.currentSession.type.code == 'P'
    },
    isRaceSession () {
      return this.currentSession.type.code == 'R'
    },
    tab: {
      set(tab) {
        if (tab == this.tab) {
          return;
        }
        
        this.$router.replace({ query: { ...this.$route.query, tab } });
        
        if ( this.tab != "results") {
          if (this.sessionresults) {
            this.sessionresults = undefined;
          }
        } else {
          this.sessionresults = this.storedResultsSession || this.officialSessions[0]._id
        }
      },
      get() {
        if (this.$route.query.tab) return this.$route.query.tab;
        return "info";
      },
    },
    sessionresults: {
      set(sessionresults) {
        if (sessionresults == this.sessionresults) {
          return;
        }
        
        if ( sessionresults !== undefined ) {
          this.storedResultsSession = sessionresults;
        }
        
        this.$router.replace({ query: { ...this.$route.query, sessionresults } });
        
        this.currentSession = this.sessionHashmap[this.sessionresults];
      },
      get() {
        if (this.$route.query.sessionresults) return this.$route.query.sessionresults;
        return "";
      }
    },
    officialSessions() {
      if ( !this.event || !this.event.sessions || this.event.sessions.length < 1 ) {
        return [];
      }
      
      return this.event.sessions.filter ( s => s.official )
    }
  },
  async mounted() {
    await this.getEvent(this.$route.params.id);
    await this.getSeason(this.event.season._id);
    await this.updatePrequalHashMap();
    await this.getUserPermissions();
    if (this.season.rules.licensePoints && this.season.rules.licensePoints.enabled) {
      try {
        await this.getUserRoles();
        this.licensePointRolesLoaded = true;
      } catch (error) {
        this.licensePointRolesLoaded = false;
      }
    }
    
    await this.getUserSeasonClasses(this.event.season._id);

    await this.updateSeasonRegistrationsTableData();
    await this.updateEventResultsTableData();
    
    // Update session hashmap
    this.event.sessions.forEach ( session => {
      this.sessionHashmap[session._id] = session
    })
    
    // Make sure to set sessionresults if we're loading straight into the results tab:
    if ( this.$route.query.tab && this.$route.query.tab == 'results' ) {      
      this.sessionresults = this.storedResultsSession || this.officialSessions[0]._id
    }
    
    this.storedResultsSession = this.sessionresults;
    this.currentSession = this.sessionHashmap[this.sessionresults];

    this.updateRSVPOpen();

    if (this.isLoggedIn) {
      await this.updateUserAvailableCars();
      await this.updateRSVPCar();

      // Check if user is suspended from this event:
      let suspendedDrivers = this.event.suspendedDrivers || [];
      this.driverSuspended = suspendedDrivers.map(sd => sd.toString()).includes(this.userinfo.id.toString())
    }

    this.eventResultsLeaderLaps = this.event.results[0] ? this.event.results[0].numLaps : 0;

    if (this.event.results[0] && this.event.results[0].race) {
      // daca am race, adica eventul are 2 curse
      this.eventResultsLeaderLaps = [];
      this.eventResultsLeaderLaps[this.event.results[0].race] = this.event.results[0].numLaps; // tururi lider prima cursa
      for (let i = this.event.results.length - 1; i >= 0; i--) {
        this.eventResultsLeaderLaps[this.event.results[i].race] = this.event.results[i].numLaps;
      }
    }
  },
};
</script>

<style>
.event-header {
  gap: 4px;
  flex-wrap: wrap;
}

.event-title {
  line-height: 1.2;
  word-break: normal;
}

.event-tab-content {
  padding: 8px;
}

.prequal-table-column {
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
}

.prequal-registration-table {
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.race-results-table .v-data-table__wrapper,
.prequal-registration-table .v-data-table__wrapper {
  max-width: 100%;
  overflow-x: hidden !important;
}

.race-results-table table,
.prequal-registration-table table {
  table-layout: fixed;
  max-width: 100%;
  min-width: 0 !important;
  width: 100%;
}

.race-results-table th,
.race-results-table td,
.prequal-registration-table th,
.prequal-registration-table td {
  overflow-wrap: anywhere;
  padding-left: 2px !important;
  padding-right: 2px !important;
  white-space: normal;
}

.prequal-registration-table .prequal-drivers {
  min-width: 0;
}

.prequal-registration-table .prequal-best-laps,
.prequal-registration-table .prequal-result,
.prequal-registration-table .prequal-car {
  min-width: 0;
}

.prequal-registration-table .prequal-car {
  gap: 0;
  justify-content: flex-start;
}

.prequal-registration-table .prequal-car__name {
  flex: 1 1 auto;
  min-width: 0;
}

.result-livery {
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 960px) {
  .rlr-result-entry {
    flex-direction: column;
  }

  .race-results-table th,
  .race-results-table td {
    font-size: 0.75rem;
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
}

@media (max-width: 600px) {
  .event-header {
    padding-left: 4px !important;
    padding-right: 8px !important;
  }

  .event-title {
    font-size: 1.35rem !important;
  }

  .event-tab-content {
    padding: 4px;
  }
}

.v-row-group__header .text-start button:nth-of-type(2) {
  display: none;
}
.v-data-table {
  line-height: 1.2!important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  min-height: 32px!important;
}

/*-----------LUC 2026-------------*/
kbd.driver-class {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 40px;     /* makes all boxes same width */
  height: 24px;
  padding: 0 8px;

  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;

  line-height: 1;

  /*border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.4);*/

  background-color: #000;  /* fallback */
  color: #fff;
  border-radius: 3px;
}

/* Secondary (extra) driver classes → circle */
kbd.driver-class.driver-class--secondary {
  min-width: 24px;   /* override base */
  width: 24px;
  height: 24px;
  padding: 0;

  border-radius: 50%;
  font-size: 11px;
  letter-spacing: 0;
  vertical-align: middle;
}

/* === Race number column === */
.race-number {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  width: 42px;          /* enough for #999 */
  min-height: 24px;
  text-align: right;    /* KEY */

  margin-right: 6px;    /* spacing after number */
}

.crew-alignment,
.driver-result-entry {
  display: inline-flex;
  align-items: center;
}

.crew-alignment {
  flex-wrap: wrap;
  min-height: 24px;
}

.driver-result-entry {
  min-height: 24px;
}

.rlr-result-entry {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 24px;
  white-space: nowrap;
}

.rlr-result-change {
  align-self: center;
  height: 18px !important;
  justify-content: center;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  min-width: 36px;
  padding-left: 3px !important;
  padding-right: 3px !important;
  transform: translateY(-1px);
  width: 36px;
}

.crew-line-break {
  flex-basis: 100%;
  height: 0;
}

.driver-profile-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin: -2px;
  padding: 2px;
  border-radius: 3px;
  color: inherit !important;
  text-decoration: none;
  transition: color 120ms ease, background-color 120ms ease;
}

.driver-profile-link .v-icon {
  color: inherit;
  opacity: 0.65;
}

.driver-profile-link:hover,
.driver-profile-link:focus {
  color: var(--v-primary-base) !important;
  background-color: rgba(127, 127, 127, 0.12);
  text-decoration: none;
}

.driver-profile-link:focus-visible {
  outline: 2px solid var(--v-primary-base);
  outline-offset: 1px;
}

.prequal-drivers {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 210px;
}

.prequal-driver {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.prequal-driver__avatar {
  flex: 0 0 auto;
}

.prequal-driver__details {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 48px;
  position: relative;
}

.prequal-driver__details .rlr-rating-chip.v-chip,
.prequal-driver__details .license-points-chip.v-chip {
  height: 16px;
}

.prequal-driver__identity {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 600;
}

.license-points-chip.v-chip {
  background-color: #f1f3f5 !important;
  cursor: pointer;
  border-radius: 4px;
  box-shadow:
    inset 3px 0 0 #9ea7ad,
    inset 6px 0 0 #c2c8cc,
    inset 9px 0 0 #9ea7ad;
  color: #37474f;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  height: 18px;
  justify-content: center;
  padding: 0 0 0 9px;
  width: 40px;
}

.rlr-rating-chip.v-chip {
  background-color: #eceff1 !important;
  border-radius: 4px;
  box-shadow:
    inset 3px 0 0 #607a9e,
    inset 6px 0 0 #d8c76a,
    inset 9px 0 0 #b96f76;
  color: #37474f;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  height: 18px;
  justify-content: center;
  padding: 0 0 0 9px;
  width: 40px;
}

.prequal-driver__rating-chip {
  flex: 0 0 40px;
  margin-left: 0 !important;
  position: absolute;
  right: 0;
  top: 0;
}

.prequal-driver__subtitle-row {
  align-items: center;
  display: flex;
  min-width: 0;
}

.prequal-driver__subtitle-metrics {
  align-items: center;
  display: inline-flex;
  flex: 0 0 40px;
  justify-content: center;
  bottom: 0;
  margin-left: 0 !important;
  position: absolute;
  right: 0;
  width: 40px;
}

.prequal-driver__subtitle-metrics--rating-slot {
  bottom: auto;
  top: 0;
}

.prequal-driver__lp-decision {
  position: absolute;
  right: 44px;
}

.license-points-chip.license-points-chip--qualifying.v-chip {
  box-shadow:
    inset 3px 0 0 #d8b74f,
    inset 6px 0 0 #c2c8cc,
    inset 9px 0 0 #9ea7ad;
}

.license-points-chip.license-points-chip--race-ban.v-chip {
  box-shadow:
    inset 3px 0 0 #d8b74f,
    inset 6px 0 0 #d78345,
    inset 9px 0 0 #9ea7ad;
}

.license-points-chip.license-points-chip--elimination.v-chip {
  box-shadow:
    inset 3px 0 0 #d8b74f,
    inset 6px 0 0 #d78345,
    inset 9px 0 0 #b96f76;
}

.license-point-decision-indicator {
  align-items: center;
  border: 1px solid;
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 18px;
  font-size: 0.7rem;
  font-weight: 800;
  height: 18px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: 18px;
}

.license-point-decision-indicator--qualifying {
  background-color: #fff8e1;
  border-color: #f9a825;
  color: #8d6e00;
}

.license-point-decision-indicator--race-ban {
  background-color: #fff3e0;
  border-color: #ef6c00;
  color: #bf360c;
}

.license-point-decision-indicator--elimination {
  background-color: #ffebee;
  border-color: #c62828;
  color: #b71c1c;
}

.license-point-decision-tooltip-line + .license-point-decision-tooltip-line {
  margin-top: 4px;
}

.license-points-summary-chip.v-chip,
.license-point-history-chip.v-chip {
  border-left: 3px solid #9e9e9e;
  border-radius: 4px;
  color: #37474f;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.license-points-summary-chip.license-points-chip--qualifying,
.license-point-history-chip.license-points-chip--qualifying {
  border-left-color: #f9a825;
}

.license-points-summary-chip.license-points-chip--race-ban,
.license-point-history-chip.license-points-chip--race-ban {
  border-left-color: #ef6c00;
}

.license-points-summary-chip.license-points-chip--elimination,
.license-point-history-chip.license-points-chip--elimination {
  border-left-color: #c62828;
}

.license-point-history-chip--superseded.v-chip,
.license-point-status-chip--cancelled.v-chip {
  background-color: #eceff1 !important;
  color: #607d8b;
}

.license-point-status-chip.v-chip {
  border-radius: 4px;
  font-weight: 700;
}

.license-point-status-chip--new.v-chip {
  background-color: #e3f2fd !important;
  color: #1565c0;
}

.license-point-status-chip--pending.v-chip {
  background-color: #fff8e1 !important;
  color: #8d6e00;
}

.license-point-status-chip--served.v-chip {
  background-color: #e8f5e9 !important;
  color: #2e7d32;
}

.license-point-status-chip--overdue.v-chip {
  background-color: #ffebee !important;
  color: #c62828;
}

.license-point-clean-progress {
  align-items: center;
  display: flex;
  gap: 6px;
}

.license-point-clean-progress__dot {
  background-color: #cfd8dc;
  border-radius: 50%;
  display: inline-block;
  height: 9px;
  width: 9px;
}

.license-point-clean-progress__dot--complete {
  background-color: #2e7d32;
}

.license-point-clean-progress__count {
  color: #546e7a;
  font-size: 0.75rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin-left: 4px;
}

.license-point-crossing--superseded {
  opacity: 0.62;
}

.prequal-driver__number {
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-right: 6px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  text-align: right;
  white-space: nowrap;
}

.prequal-best-laps {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 120px;
}

.prequal-best-lap {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 44px;
  text-align: center;
}

.prequal-best-lap__time {
  font-size: 1.05rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.prequal-best-lap__label {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1.2;
  margin-top: 3px;
  white-space: nowrap;
}

.prequal-driver__subtitle {
  margin-top: 2px;
  font-size: 0.75rem;
  line-height: 1.2;
}

.prequal-car {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 210px;
}

.prequal-car__model {
  font-weight: 600;
  line-height: 1.2;
}

.prequal-car__make {
  margin-bottom: 2px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.1;
  text-transform: uppercase;
}

.prequal-car__image {
  flex: 0 0 110px;
}

.prequal-result {
  min-width: 130px;
  text-align: center;
}

.prequal-result__average {
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.prequal-result__laps {
  margin-top: 3px;
  font-size: 0.75rem;
  line-height: 1.2;
  white-space: nowrap;
}

.prequal-gap {
  font-weight: 700;
  white-space: nowrap;
}

.prequal-gap--leader {
  color: var(--v-success-base);
  letter-spacing: 0.04em;
}

@media (max-width: 960px) {
  .prequal-car {
    min-width: 0;
  }

  .prequal-mobile-list {
    margin: 0 -8px;
  }

  .prequal-mobile-split {
    padding: 8px 12px 6px;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .prequal-mobile-card {
    border-bottom: 1px solid rgba(127, 127, 127, 0.25) !important;
  }

  .prequal-mobile-driver-copy {
    min-width: 0;
  }

  .prequal-mobile-driver-row {
    min-height: 76px;
  }

  .prequal-mobile-team-header-row {
    min-height: 44px;
    padding-bottom: 4px;
  }

  .prequal-mobile-team-position {
    align-items: center;
    display: flex;
    font-size: 2.5rem;
    height: 44px;
    justify-content: flex-end;
    line-height: 44px;
  }

  kbd.driver-class.prequal-mobile-team-car-class {
    flex: 0 0 44px;
    height: 44px;
    min-width: 44px;
    padding: 0;
    width: 44px;
  }

  .prequal-mobile-team-entry-copy {
    flex: 1 1 auto;
    min-width: 0;
  }

  .prequal-mobile-team-driver-row {
    min-height: 48px;
  }

  .prequal-mobile-team-driver-copy {
    min-width: 0;
  }

  .prequal-mobile-team-driver-copy > .text-truncate {
    min-width: 0;
  }

  .prequal-mobile-driver-summary {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
  }

  .prequal-mobile-position {
    color: currentColor;
    font-size: 2rem;
    font-weight: 800;
    letter-spacing: -0.06em;
    line-height: 1;
    max-width: 100%;
    text-align: right;
    white-space: nowrap;
    width: 100%;
  }

  .prequal-mobile-position--first { color: #c49a25 !important; }
  .prequal-mobile-position--second { color: #9e9e9e !important; }
  .prequal-mobile-position--third { color: #b9845a !important; }

  .prequal-mobile-detail-row {
    min-height: 68px;
  }

  .prequal-mobile-detail-row--car {
    min-height: 60px;
  }

  .prequal-mobile-detail-row--result {
    min-height: 56px;
  }

  .prequal-mobile-detail-row--attendance {
    min-height: 44px;
  }

  .prequal-mobile-average-indicator {
    align-items: center;
    border: 2px solid currentColor;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 32px;
    justify-content: center;
    line-height: 1;
    width: 32px;
  }

  .prequal-mobile-average-indicator__line {
    border-top: 1px solid currentColor;
    margin-top: 0;
    opacity: 0.65;
    width: 18px;
  }

  .prequal-mobile-average-indicator__laps {
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 1;
    margin-top: 0;
  }
  .prequal-mobile-car-copy {
    min-width: 0;
  }

  .prequal-mobile-car-fallback {
    min-width: 0;
    width: 100%;
  }

  .prequal-mobile-car-image {
    flex: 0 0 130px;
    max-width: 130px;
  }

  .prequal-mobile-gap {
    font-size: 1.25rem;
  }
  .prequal-mobile-section-divider {
    margin-left: 0;
    width: 100%;
  }
}

/*--------------LUC 2026------------*/
</style>
